namespace cdh.ui {

    function lazyContentLoader(this: HTMLElement) {

        let cl = ContentLoader.getLoader(this);

        if (cl != null)
            cl.loadContent();

    };

    function handleCommandBase<TKey = any>(container: JQuery<HTMLElement>, commandHandler: ObservableOrValue<ICommandManager<TKey>>, argFunc?: { (elm: HTMLElement): TKey }) {
        container.on("click.dx", "[data-cmd]", function () {

            let $this = $(this);
            let cmd = $this.data("cmd");
            let id: TKey;
            if (argFunc === undefined)
                id = $this.closest("[data-id]").data("id");
            else
                id = argFunc(this);

            let handler = ko.unwrap(commandHandler);

            if (handler != null)
                handler.sendCommand(cmd, id, this);
        });
    }

    export class ContentLoader {

        private _jqXhr: JQuery.jqXHR;
        readonly state = ko.observable<"notLoaded" | "loading" | "loaded" | "error">("notLoaded");
        readonly url: KnockoutObservable<string>;

        constructor(readonly elm: JQuery<HTMLElement>, readonly contentElm: JQuery<HTMLElement>, url: ObservableOrValue<string>) {

            if (ko.isObservable(url))
                this.url = url;
            else
                this.url = ko.observable(url);

            this.url.subscribe(this.unloadContent, this);
        }

        static getLoader(element: HTMLElement & { _contentLoader?: ContentLoader }, content?: HTMLElement | string, cntUrl?: ObservableOrValue<string>) {
            let elm = $(element); // div.panel-collapse.collapse
            let cElm: JQuery<HTMLElement>;

            if (element._contentLoader)
                return element._contentLoader;

            if (cntUrl === undefined)
                cntUrl = elm.data("content-url");

            if (!cntUrl)
                return null;

            if (typeof content == "string" && content)
                cElm = elm.find(content).first();
            else if (content)
                cElm = $(<any>content);
            else {
                cElm = elm.find(".card-body").first();
            }

            return element._contentLoader = new ContentLoader(elm, cElm, cntUrl);

        }

        loadContent(reload?: boolean) {
            let self = this;

            if (reload)
                self.unloadContent();

            let s = ko.unwrap(this.state);

            if (s === "loading" || s === "loaded")
                return;

            var url = ko.unwrap(self.url);

            if (!url) {
                this.state("notLoaded");
                this.contentElm.html("");
                return;
            }

            self.state("loading");

            self.contentElm.html("<span class='fa fa-sync spin'></span> <span>" + t("view/common/loading") + "</span>");

            self._jqXhr = $.get(url, null, function (data, evnt) {

                self.contentElm.html(data);

                self.state("loaded");
                self._jqXhr = null;

            }).fail(function (jqXHR, status, errorThrown) {

                if (jqXHR.readyState === 4 && jqXHR.getResponseHeader("content-type").indexOf("text/html") >= 0) {
                    self.contentElm.html(jqXHR.responseText);
                }
                else {
                    self.contentElm.html(errorThrown);
                }
                self.state("error");
                self._jqXhr = null;
            });
        }

        unloadContent() {
            let self = this;

            if (self._jqXhr)
                self._jqXhr.abort();

            self.state("notLoaded");
            self.contentElm.html("");
        }


    }

    export function bindModel<T = any>(selector: string | string[], model: T) {

        if (selector && model)
            if ($.isArray(selector))
                selector.forEach(s => bindModel(s, model));
            else if (typeof (selector) === "string")
                $(selector).each((i, e) => ko.applyBindings(model, e));
    }

    export function bindSearchModels() {
        $.each($("[data-area-search-url]"), function (i, node) {
            var elm = $(node);

            var vm = new viewModels.AreaSearchViewModel(elm.data("area-search-url"), elm.data("area-search-radius"), elm.data("area-search-lat"), elm.data("area-search-lon"));

            ko.applyBindings(vm, node);
        });

        $.each($("[data-search-url]"), function (i, node) {
            var elm = $(node);

            var c: { new(url: string, name: string): viewModels.GeneralSearchViewModel } = viewModels.GeneralSearchViewModel;

            var tmp = elm.data("search-handler");
            if (tmp) {
                c = utils.stringToFunction<{ new(url: string, name: string): viewModels.GeneralSearchViewModel }>(tmp)
            }

            var vm = new c(elm.data("search-url"), elm.data("search-name"));

            vm.type(elm.data("search-type") || viewModels.StringSearchTypes.Contains);
            vm.term(elm.data("search-term"));

            ko.applyBindings(vm, node);
        });

    };

    export function bindMenuModel<T>(menu: T) {
        $.each($(".main-menu"), function (i, node) {
            var elm = $(node);

            ko.applyBindings(menu, node);
        });
    }

    export function bindLazyContentLoaders() {
        $("body").on("show.bs.collapse", ".collapse", lazyContentLoader);
    }

    export function getErrorClass(severity: ModelStateErrorSeverity, prefix?: string) {
        if (!prefix) prefix = "text-";
        switch (ko.unwrap(severity)) {

            case ModelStateErrorSeverity.info: return prefix + "info";
            case ModelStateErrorSeverity.warning: return prefix + "warning";
            default: return prefix + "danger";
        }
    }

    function isLookupCollectionFunctions<T, TValue = string>(obj: unknown): obj is ILookupCollectionFunctions<T, TValue> {
        if (obj == null || (typeof (obj) !== "function" && typeof (obj) !== "object"))
            return false;
        else
            return typeof (<ILookupCollectionFunctions<T>>obj).createCustomItem === "function";
    }

    function getLookupCollectionFunctions<T>(options: ObservableOrValueModel<DevExpress.ui.DataExpressionMixinOptions>) {
        var items: unknown = options.items || options.dataSource;

        if (isLookupCollectionFunctions<T>(items)) {
            return items;
        }
        return null;
    }

    function setOption<T, K extends keyof T>(option: ObservableOrValueModel<T>, name: K, value: T[K]): boolean;
    function setOption<T, K extends keyof T>(option: T, name: K, value: T[K]): boolean;
    function setOption<T, K extends keyof T>(option: T, name: K, value: T[K]) {
        if (!option || option[name] !== undefined) return false;

        option[name] = value;
        return true;
    }

    function toArray(names: string | string[]): string[] {
        let arr: string[];

        if ($.isArray(names)) {
            arr = names.slice();
        }
        else if (typeof names == "string")
            arr = [names]
        else
            arr = [];

        arr = arr.filter(n => !!n);

        return arr;
    }

    export function customItemCreateFunc<T, K extends Extract<keyof T, string> = Extract<keyof T, string>>(valfield: K | K[], emptyFields?: K | K[]): { (txt: string): Partial<T> };
    export function customItemCreateFunc(valfield: string | string[], emptyFields?: string | string[]): { (txt: string): Dictionary<string> };
    /**
     * Generates a Function for creating Custom Items for a User Input
     * @param valfield Name(s) of Field(s) that will be filled with the Input
     * @param emptyFields Name(s) of Field(s) that will be filled with an empty String
     */
    export function customItemCreateFunc(valfield: string | string[], emptyFields?: string | string[]) {
        let tFields: string[];
        let eFields: string[];

        tFields = toArray(valfield);
        eFields = toArray(emptyFields);

        return function (value: string): Dictionary<string> {
            if (value) {
                var res: Dictionary<string> = {};

                tFields.forEach(n => res[n] = value);
                eFields.forEach(n => res[n] = "");

                return res;
            }
            else
                return null;
        }
    }


    export function customItemFunc<T, K extends Extract<keyof T, string> = Extract<keyof T, string>>(valfield: K | K[], emptyFields?: K | K[]): (args: { text?: string, customItem?: object }) => void;
    export function customItemFunc(valfield: string | string[], emptyFields?: string | string[]): (args: { text?: string, customItem?: object }) => void;
    export function customItemFunc(valfield: string | string[], emptyFields?: string | string[]): (args: { text?: string, customItem?: object }) => void {
        var createItem = customItemCreateFunc(valfield, emptyFields);

        return value => {

            if (value && typeof (value.text) === "string")
                value.customItem = createItem(value.text);
            else
                value.customItem = null;
        }
    }

    // Q> Convert add...Options/get...Options Functions into Bindinghandlers?
    //    Converting would have the following advantages:
    //     - It Could reduce the Amount of text to Write in the View
    //     - It will possible to access the BindingContext, etc.
    // The Add/Get Options Methods are helpers that prepare the Options for DevExtreme Widgets

    // Q> Values for true and false (Parameter)?
    export function prepareCheckBoxForIndexValue(e: { component?: DevExpress.ui.dxDataGrid, element?: DevExpress.core.dxElement, model?: any, parentType?: string, value?: any, setValue?: any, updateValueTimeout?: number, width?: number, disabled?: boolean, rtlEnabled?: boolean, cancel?: boolean, editorElement?: DevExpress.core.dxElement, readOnly?: boolean, editorName?: string, editorOptions?: any, dataField?: string, row?: DevExpress.ui.dxDataGridRowObject }) {

        e.editorElement.dxCheckBox({
            value: e.value == 1 || e.value == "1",
            readOnly: e.readOnly,
            onValueChanged: e2 => {
                var val = e2.value ? 1 : 0;
                e.setValue(val);
            }
        });

        e.cancel = true;
    }

    export function addTabPanelOptions(options: DevExpress.ui.dxTabPanelOptions, o2: Dictionary<any>) {

        setOption(options, "height", '100%');

        setOption(options, "loop", true);
        setOption(options, "animationEnabled", true);
        setOption(options, "showNavButtons", true);
        setOption(options, "scrollByContent", true);

        if (o2 != null)
            $.each(options.items, (ix, item: MappableObject) => {
                if (item == null && typeof item !== "object") return;

                $.each(o2, (k, v) => {
                    if (!item.hasOwnProperty(k))
                        item[k] = v;
                });
            });

        // This fix is necessary since in some cases the Translations aren't applied (I don't know why).
        if (options.onItemRendered === undefined)
            options.onItemRendered = e => {
                let n = e.itemElement[0];
                if (n) localization.applyTranslationsStatic(n);
            }

        return options;
    }

    export function addDataGridOptions(options: DevExpress.ui.dxDataGridOptions, model?: any, addEdit?: boolean) {

        options = options || {};

        var cmdMgr: ICommandManager<any> = null;
        var sel = false;

        if (model instanceof viewModels.DialogSearcherViewModelBase || model instanceof viewModels.SearchableDataSource) {
            setOption(options, "remoteOperations", { paging: true, filtering: true, sorting: true });
            setOption(options, "dataSource", model.source);
        }

        if (model && "commandHandler" in model) {
            cmdMgr = model.commandHandler;
            if (cmdMgr && !("sendCommand" in cmdMgr))
                cmdMgr = null;
        }

        setOption(options, "filterRow", { visible: false });
        setOption(options, "columnFixing", { enabled: true });
        if (options.columns && options.columns.length > 3)
            setOption(options, "columnChooser", { enabled: true, mode: 'select' });

        setOption(options, 'allowColumnReordering', true);
        setOption(options, 'allowColumnResizing', true);
        setOption(options, 'columnAutoWidth', true);
        var oSel = setOption(options, 'selection', { mode: 'single' });

        if (setOption(options, "scrolling", { mode: "virtual", rowRenderingMode: "virtual" }))
            setOption(options, "paging", { pageSize: 100 });

        setOption(options, "sorting", { mode: "multiple" });

        setOption(options, 'showColumnLines', false);
        setOption(options, 'showRowLines', true);

        if (typeof (model) === "object" && model !== null) {


            if (options.focusedRowKey === undefined && (options.focusedRowEnabled === undefined || options.focusedRowEnabled == true) && ko.isObservable(model.focused)) {
                options.focusedRowEnabled = true;
                options.focusedRowKey = model.focused;
                sel = true;
            }


            if (options.selectedRowKeys === undefined && ko.isObservable(model.selected)) {
                options.selectedRowKeys = model.selected;
                sel = true;
            }

            if (options.onSelectionChanged === undefined && ko.isObservable(model.selectedItems)) {
                options.onSelectionChanged = searchDialogSelectionChangedHandler;
                sel = true;
            }

            if (oSel && utils.unpeek(model.multiSelection)) {
                //if (ko.isObservable(model.multiSelection)) {
                //    var ms:KnockoutObservable<boolean> = model.multiSelection;
                //    options.selection = ko.pureComputed(() => ms() ? { mode: "multiple" } : { mode: "single" });
                //}

                options.selection = { mode: "multiple", showCheckBoxesMode: "always", allowSelectAll: false };
            }
        }

        if (options.onRowClick === undefined && options.onRowDblClick === undefined)
            if (cmdMgr) {
                options.onRowDblClick = async (e) => {
                    var key = e.key;
                    cmdMgr.sendCommand("default", key, e.rowElement[0])
                }
            }
            else if (sel)
                options.onRowClick = searchDialogRowClickHandler;

        if (addEdit && options.editing === undefined) {
            options.editing = {
                mode: "row",
                refreshMode: 'full',

                allowAdding: true,
                allowUpdating: true,
                allowDeleting: true,
            }
        }

        if (options.editing != null && options.editing.mode == "row" && cmdMgr instanceof utils.MultiCommandManager
            && (options.editing.allowAdding || options.editing.allowUpdating || options.editing.allowDeleting)) {

            var cMgr: utils.MultiCommandManager<any> = cmdMgr;

            options.onInitialized = e => cMgr.addHandlersStart(new viewModels.InGridEditorCommandHandler(e.component));

        }

        return options;
    }

    export function addNewCommandToolbarButton(commandHandler: ICommandManager<any>, visible?: boolean): ((e: { component?: any, element?: DevExpress.core.dxElement, model?: any, toolbarOptions?: DevExpress.ui.dxToolbarOptions }) => any) {

        if (commandHandler && commandHandler.sendCommand)
            return e => {

                var o2: DevExpress.ui.dxButtonOptions = {
                    hint: t("view/common/create"),
                    icon: "fa fa-plus",


                    onClick: e => commandHandler.sendCommand("create", null, e.element[0])
                }

                if (visible !== undefined)
                    o2.visible = visible;


                e.toolbarOptions.items.unshift({
                    location: "after",
                    widget: "dxButton",
                    options: o2
                });

            }

        return null;
    }

    export function addDataGridCommandColumn(options?: DevExpress.ui.dxDataGridColumn) {
        options = options || {};

        setOption(options, "name", "cmdCol");
        options.caption = "";

        setOption(options, "cellTemplate", "commandCell");
        setOption(options, "headerCellTemplate", "commandHeader");

        options.allowEditing = false;
        options.allowHiding = options.allowHiding || false;
        options.allowResizing = options.allowResizing || false;
        options.allowReordering = options.allowReordering || false;
        options.allowSorting = options.allowSorting || false;
        options.allowSearch = options.allowSearch || false;
        options.allowExporting = options.allowExporting || false;
        options.allowGrouping = options.allowGrouping || false;
        options.showInColumnChooser = options.showInColumnChooser || false;

        if (setOption(options, "fixed", true))
            options.fixedPosition = "right";


        return options;
    }

    export function getDefaultCommandDefinition(name: DefaultCommands): CommandDefinition {
        let res: CommandDefinition = null;

        if (typeof name === "string") {
            switch (name) {
                case "edit":
                    res = { name: 'edit', text: cdh.t('view/common/edit'), icon: 'fa fa-edit', visible: true };
                    break;
                case "delete":
                    res = { name: 'delete', text: cdh.t('view/common/delete'), color: "danger", icon: 'fa fa-times', visible: true };
                    break;
            }
        }

        return res;
    }

    export function addDataGridButtonColumn(options?: DevExpress.ui.dxDataGridColumn, commandHandler?: ICommandManager<any>, commands?: (CommandDefinition | DefaultCommands)[], dataFunc?: (row: any, data: Dictionary<any>) => void, keyFunc?: (key: any) => any) {
        options = options || {};

        if (!options.name)
            options.name = "btns";
        options.caption = "";

        options.type = "buttons";

        options.buttons = [
            { name: "save", icon: "fa fa-check", cssClass: "text-primary" },
            { name: "cancel", icon: "fa fa-times", cssClass: "text-primary" },
            { name: "edit", icon: "fa fa-edit", cssClass: "text-primary" },
            { name: "delete", icon: "fa fa-trash", cssClass: "text-primary" }
        ];

        if (commandHandler) {
            $.each(commands, (i, v) => {
                if (typeof (v) === "string")
                    v = getDefaultCommandDefinition(v);

                if (typeof (v) === "object" && v && v.name) {
                    var cmd = v;

                    options.buttons.push({
                        hint: (cmd.text || cmd.name) as string,
                        icon: cmd.icon,
                        cssClass: "text-" + (cmd.color || "primary"),
                        visible: cmd.visible,

                        onClick: e => {
                            var data: Dictionary<any> = {};
                            if (dataFunc)
                                try {
                                    dataFunc(e.row.data, data);
                                }
                                catch (ex) {
                                    console.warn("Error while attaching RowData for Command", ex);
                                }

                            var key = e.row.key;
                            if (keyFunc)
                                key = keyFunc(key);

                            commandHandler.sendCommand(cmd.name, key, e.element[0], data);
                        }
                    });
                }
            });
        }

        options.allowEditing = false;
        options.allowHiding = options.allowHiding || false;
        options.allowResizing = options.allowResizing || false;
        options.allowReordering = options.allowReordering || false;
        options.allowSorting = options.allowSorting || false;
        options.allowSearch = options.allowSearch || false;
        options.allowExporting = options.allowExporting || false;
        options.allowGrouping = options.allowGrouping || false;
        options.showInColumnChooser = options.showInColumnChooser || false;

        if (setOption(options, "fixed", true))
            options.fixedPosition = "right";


        return options;
    }

    export function addSelectBoxOptions(options: ObservableOrValueModel<DevExpress.ui.dxSelectBoxOptions>, ...emptyFields: string[]) {

        options = options || {};

        setOption(options, "searchEnabled", true);
        setOption(options, "acceptCustomValue", true);

        // Q> Context for getUniqueId (Scope/Prefix)

        if ((<any>options).id == null && ko.isObservable(options.value))
            (<any>options).id = getUniqueId(options.value);

        if (options.name == null && ko.isObservable(options.value))
            options.name = getUniqueId(options.value);

        if (!(options.inputAttr && options.inputAttr.id) && ko.isObservable(options.value)) {
            if (!options.inputAttr) options.inputAttr = {};
            options.inputAttr.id = getUniqueId(options.value);
        }

        if (options.acceptCustomValue && options.onCustomItemCreating == null) {
            var createItem: (txt: string) => Dictionary<string>;

            var tmp = getLookupCollectionFunctions(options);
            if (tmp) {
                createItem = tmp.createCustomItem;
            }
            else {
                var fields: string[] = [];

                if (typeof options.valueExpr === "string")
                    fields.push(options.valueExpr);

                if (typeof options.displayExpr === "string") {

                    if (fields.length == 0 || !utils.equalsIgnoreCase(options.displayExpr, fields[0]))
                        fields.push(options.displayExpr);
                }

                createItem = customItemCreateFunc(fields, emptyFields);
            }

            if (options.dataSource instanceof DevExpress.data.DataSource) {
                throw new Error("CustomItems for DataSource Not Implemented");
            }
            else {

                let items = ko.extenders.temporaryItems((options.items || options.dataSource) as unknown as KnockoutObservableArray<any>);

                let valExpr = options.valueExpr as string;
                let itemDefs = createDictionary(items, valExpr);

                options.onCustomItemCreating = value => {
                    if (value && typeof (value.text) === "string") {
                        value.customItem = itemDefs.findItem(value.text);

                        if (value.customItem == null) {
                            value.customItem = createItem(value.text);
							if(value.customItem)
                                items.temporaryItems.push(value.customItem);
                        }
                    }
                    else
                        value.customItem = null;
                };
                let vCh = ko.unwrap(options.onValueChanged);

                var changeHandler = options.onValueChanged = e => {
                    if (vCh) vCh(e);


                    if (e.value) {
                        var tmpItems = items.temporaryItems();
                        if (tmpItems.length) {
                            //tmpItems = tmpItems.filter(i => utils.equalsIgnoreCase(ko.unwrap(i[valExpr]), e.value));
                            //items.temporaryItems(tmpItems);
                            items.temporaryItems.removeAll();
                        }

                        let kvp = itemDefs.findItem(e.value);

                        if (kvp) {
                            e.value = ko.unwrap(kvp[valExpr]);
                            //items.temporaryItems([]);
                        }
                        else {
                            items.temporaryItems([createItem(e.value)]);
                        }
                    }
                    else {
                        items.temporaryItems([]);
                    }

                }

                let oldInit = utils.unpeek(options.onInitialized);
                options.onInitialized = e => {
                    if (oldInit) oldInit(e);

                    let val = e.component.option("value");
                    changeHandler({ component: e.component, element: e.element, value: val, previousValue: val });

                    if (ko.isSubscribable(items.source))
                        items.source.subscribe(() => {
                            let val = e.component.option("value");
                            changeHandler({ component: e.component, element: e.element, value: val, previousValue: val });
                        });
                }

                options.items = items as any;
                delete options.dataSource;
            }
        }

        return options;
    }

    export function addTagBoxOptions(options: ObservableOrValueModel<DevExpress.ui.dxTagBoxOptions>, ...emptyFields: string[]) {

        options = options || {};

        if (options.searchEnabled == null)
            options.searchEnabled = true;
        if (options.acceptCustomValue == null)
            options.acceptCustomValue = true;
        if (options.hideSelectedItems == null)
            options.hideSelectedItems = true;

        if (!(options.inputAttr && options.inputAttr.id) && ko.isObservable(options.value)) {
            if (!options.inputAttr) options.inputAttr = {};
            options.inputAttr.id = getUniqueId(options.value);
        }

        if (options.acceptCustomValue && options.onCustomItemCreating == null) {
            var fields: string[] = [];

            if (typeof options.valueExpr === "string")
                fields.push(options.valueExpr);

            if (typeof options.displayExpr === "string") {

                if (fields.length == 0 || !utils.equalsIgnoreCase(options.displayExpr, fields[0]))
                    fields.push(options.displayExpr);
            }

            var createItem = customItemCreateFunc(fields, emptyFields);

            var items = ko.extenders.temporaryItems((options.items || options.dataSource) as unknown as KnockoutObservableArray<any>);

            var valExpr = options.valueExpr as string;
            var itemDefs = createDictionary(items, valExpr);

            options.onCustomItemCreating = value => {
                if (value && typeof (value.text) === "string") {
                    value.customItem = itemDefs.findItem(value.text);

                    if (value.customItem == null)
                        value.customItem = createItem(value.text);
                }
                else
                    value.customItem = null;
            };


            var baseValue: KnockoutObservable<string[]>;

            if (ko.isWriteableObservable(options.value))
                baseValue = options.value;
            else
                baseValue = ko.observable(ko.unwrap(options.value));

            var value = ko.computed({
                read: baseValue,
                write: vals => {
                    items.temporaryItems.removeAll();
                    vals = $.map(vals, v => {
                        if (v) {
                            let kvp = itemDefs.findItem(v);

                            if (kvp)
                                return ko.unwrap(kvp[valExpr]);
                            else {
                                var tmp = createItem(v);
                                items.temporaryItems.push(tmp);
                                return v;
                            }
                        }
                        else
                            return null;
                    });

                    baseValue(vals);
                }
            }).extend({ notify: 'always' });


            value(ko.unwrap(baseValue));

            options.value = value;
            options.items = items;
            options.dataSource = items;
            options.onDisposing = () => { if (value.dispose) value.dispose(); };
        }

        return options;

    }

    export function getIdForInput(inputDef: ILabelDefinition<any>) {
        if (inputDef.id !== undefined)
            return inputDef.id;
        else if (ko.isObservable(inputDef.value))
            return getUniqueId(inputDef.value);

        return null;
    }

    export function getEditorOptionsBase<TOptions extends DevExpress.ui.dxTextEditorOptions>(inputDef: IInputDefinition<any, TOptions>, options?: ObservableOrValueModel<TOptions>) {

        options = options || inputDef.options || <ObservableOrValueModel<TOptions>>{};

        options.value = inputDef.value;

        if (options.hint === undefined) {
            options.hint = inputDef.hint || inputDef.label;
        }
        if (options.placeholder === undefined) {
            options.placeholder = inputDef.placeholder || inputDef.label;
        }

        var inputAttr: any = options.inputAttr = ko.unwrap(options.inputAttr || {});
        options.elementAttr = options.elementAttr || {};

        if (options.name === undefined && inputDef.name !== undefined) {
            options.name = inputDef.name;
        }

        if (inputAttr.id === undefined) {
            let id = getIdForInput(inputDef);
            if (id)
                inputAttr.id = id;
        }

        // Q> Handling for Enabling/Disabling or ReadOnly/ReadWrite(/WriteOnly)?
        if (options.disabled === undefined) {
            if (inputDef.enable !== undefined) {
                if (ko.isObservable(inputDef.enable))
                    options.disabled = ko.pureComputed(() => ko.unwrap(inputDef.enable) === false);
                else
                    options.disabled = inputDef.enable === false;
            }
            else if (inputDef.disable !== undefined) {
                options.disabled = inputDef.disable
            }
        }

        if (options.readOnly === undefined) {
            if (inputDef.readWrite !== undefined) {
                if (ko.isObservable(inputDef.readWrite))
                    options.readOnly = ko.pureComputed(() => ko.unwrap(inputDef.readWrite) === false);
                else
                    options.readOnly = inputDef.readWrite === false;
            }
            else if (inputDef.readOnly !== undefined) {
                options.readOnly = inputDef.readOnly
            }
        }


        if (inputDef.class !== undefined)
            (<any>options.elementAttr).class = inputDef.class;

        return options;
    }

    export function isEnabledAndWriteable(inputDef: IInputDefinition<any, any>) {

        let res = true;
        if (inputDef) {
            if (inputDef.enable !== undefined)
                res = ko.unwrap(inputDef.enable) !== false;
            else if (inputDef.disable !== undefined)
                res = ko.unwrap(inputDef.disable) === true;

            if (res) {
                if (inputDef.readWrite !== undefined)
                    res = ko.unwrap(inputDef.readWrite) !== false;
                else if (inputDef.readOnly !== undefined)
                    res = ko.unwrap(inputDef.readOnly) === true;
            }
        }

        return res;
    }

    export function getTextBoxOptions(inputDef: IInputDefinition<String, DevExpress.ui.dxTextEditorOptions>, options?: ObservableOrValueModel<DevExpress.ui.dxTextEditorOptions>) {
        options = getEditorOptionsBase(inputDef, options);

        if (inputDef.optional)
            options.showClearButton = true;

        var btns = ko.unwrap(options.buttons) || [];

        if (inputDef.buttons)
            inputDef.buttons.forEach(btn => {
                btns.push({
                    name: btn.name,
                    options: {
                        icon: ko.unwrap(btn.icon),
                        hint: ko.unwrap(btn.caption),
                        onClick: e => btn.click()
                    }
                });
            });
        if (options.showClearButton)
            btns.unshift("clear");

        options.buttons = btns;

        return options;
    }

    export function getNumberBoxOptions(inputDef: INumberInputDefinition, options?: ObservableOrValueModel<DevExpress.ui.dxNumberBoxOptions>) {

        options = getEditorOptionsBase(inputDef, options);

        if (options.format === undefined) {
            if (inputDef.format !== undefined)
                options.format = inputDef.format;
            else if (typeof (inputDef.precision) === "number")
                options.format = { type: "fixedPoint", precision: inputDef.precision }
            else
                options.format = "decimal";
        }

        if (options.min === undefined && inputDef.min !== undefined)
            options.min = inputDef.min;
        if (options.max === undefined && inputDef.max !== undefined)
            options.max = inputDef.max;
        if (options.step === undefined && inputDef.step !== undefined)
            options.step = inputDef.step;

        if (inputDef.optional)
            options.showClearButton = true;

        return options;
    }

    export function getNumberBoxOptionsPrice(inputDef: INumberInputDefinition, options?: ObservableOrValueModel<DevExpress.ui.dxNumberBoxOptions>) {

        options = getEditorOptionsBase(inputDef, options);

        if (options.format === undefined) {

            options.format = { type: "currency", precision: 3, currency: "EUR" };

            if (typeof (inputDef.precision) === "number")
                options.format.precision = inputDef.precision;

            if (typeof (inputDef.currency) == "string" && inputDef.currency)
                options.format.currency = inputDef.currency;

        }

        if (options.min === undefined && inputDef.min !== undefined)
            options.min = inputDef.min;
        if (options.max === undefined && inputDef.max !== undefined)
            options.max = inputDef.max;
        if (options.step === undefined && inputDef.step !== undefined)
            options.step = inputDef.step;

        if (inputDef.optional)
            options.showClearButton = true;

        return options;
    }

    export function getCheckBoxOptions(inputDef: IInputDefinition<boolean, DevExpress.ui.dxCheckBoxOptions>, options?: ObservableOrValueModel<DevExpress.ui.dxCheckBoxOptions>) {

        options = getEditorOptionsBase(inputDef, options);

        if (options.text === undefined)
            options.text = inputDef.label;

        return options;

    }

    export function getDateBoxOptions(inputDef: IDateInputDefinition, options?: ObservableOrValueModel<DevExpress.ui.dxDateBoxOptions>, type?: "date" | "time" | "datetime") {

        options = getEditorOptionsBase(inputDef, options);

        if (!type)
            type = ko.unwrap(options.type) || inputDef.type || (ko.unwrap(inputDef.showTime) ? "datetime" : "date");
        if (utils.equalsIgnoreCase(type, "datetime"))
            type = "datetime";
        else if (utils.equalsIgnoreCase(type, "time"))
            type = "time";
        else
            type = "date";

        if (ko.isWriteableObservable(inputDef.value)) {
            if (typeof (<KnockoutDateExtender>inputDef.value).state == "function") {
                let ext: KnockoutDateExtender | KnockoutDatetimeExtender = inputDef.value as any;

                if ((type == "date" || type == "time") && type in ext)
                    options.value = (ext as KnockoutDatetimeExtender)[type].date;
                else
                    options.value = ext.state().dateObj;
            }
            else {
                let obs = <KnockoutObservable<moment.Moment>>inputDef.value;
                options.value = ko.pureComputed<Date>({
                    read: () => {
                        let val = ko.unwrap(obs);
                        let dt: Date = null;
                        if (moment.isMoment(val) && val.isValid())
                            dt = val.toDate();
                        else if (val instanceof Date)
                            dt = val;

                        return dt;
                    },
                    write: (val: Date | moment.Moment) => {
                        let m: moment.Moment = null;
                        if (val instanceof Date)
                            m = moment(val);
                        else if (moment.isMoment(val) && val.isValid())
                            m = val;

                        obs(m);
                    }
                })
            }
        }

        //setOption(options, "openOnFieldClick", true);
        setOption(options, "onFocusIn", (e: DxWidgetEventArgs<DevExpress.ui.dxDateBox, any>) => {
            setTimeout(() => {
                if (!e.component.option("opened"))
                    e.component.open();
            }, 50);
        });

        if (options.displayFormat === undefined) {
            options.displayFormat = utils.getDateDxFormat(type);
        }


        if (options.min === undefined && inputDef.min !== undefined)
            options.min = inputDef.min;
        if (options.max === undefined && inputDef.max !== undefined)
            options.max = inputDef.max;

        if (inputDef.optional)
            setOption(options, "showClearButton", true);

        switch (type) {
            case "datetime":
                setOption(options, "type", "datetime");

                break;
            case "time":
                setOption(options, "type", "time");
                //setOption(options, "pickerType", "rollers");
                break;
            default:
                setOption(options, "type", "date");
                var calOptions = options.calendarOptions = ko.unwrap(options.calendarOptions) || {};
                setOption(calOptions, "showTodayButton", true);
                break;
        }

        return options;
    }

    export const getDateBoxOptions2 = getDateBoxOptions;

    export function getDropDownBoxOptions(inputDef: IInputDefinition<any, DevExpress.ui.dxDropDownBoxOptions>, options?: ObservableOrValueModel<DevExpress.ui.dxDropDownBoxOptions>) {
        options = getEditorOptionsBase(inputDef, options);

        if (inputDef.onEdited) {

            let _isFocused = false;
            let _isOpened = false;
            let _val: any;

            let _onEdit = inputDef.onEdited;
            let _onOpened = options.onOpened;
            let _onClosed = options.onClosed;
            let _onFocusIn = options.onFocusIn;
            let _onFocusOut = options.onFocusOut;

            options.onOpened = e => {
                let h = ko.unwrap(_onOpened)
                if (h) h(e);

                if (!_isFocused)
                    _val = e.component.option("value");

                _isOpened = true;
            };

            options.onClosed = e => {
                let h = ko.unwrap(_onClosed)
                if (h) h(e);

                _isOpened = false;
                if (!_isFocused && _val !== e.component.option("value"))
                    _onEdit(e);
            };

            options.onFocusIn = e => {
                let h = ko.unwrap(_onFocusIn)
                if (h) h(e);

                if (!_isOpened)
                    _val = e.component.option("value");

                _isFocused = true;
            }

            options.onFocusOut = e => {
                let h = ko.unwrap(_onFocusOut)
                if (h) h(e);

                _isFocused = false;
                if (!_isOpened && _val !== e.component.option("value"))
                    _onEdit(e);
            };

        }

        return options;
    }

    export function importBaseOption<TItem = any, TValue = any>(inputDef: ILookupInputDefinition<DevExpress.ui.dxSelectBoxOptions, TItem, TValue>) {
        var items: unknown = inputDef.items;
        if (items && (<ILookupCollectionFunctions<TItem>>items).baseOptions) {
            inputDef = utils.extend(inputDef, (<ILookupCollectionFunctions<TItem>>items).baseOptions)
        }

        return inputDef;
    }

    export function extendLabel<T extends IInputDefinition<any, any>>(inputDef: T): T {
        var def: Mutable<IInputDefinition<any, any>> = inputDef;
        var lbl = def.label;

        if (inputDef.label) {
            if (inputDef.labelExtension) {
                def.label = extendText(def.label, def.labelExtension);

                if (isExtendedTextObservable(lbl))
                    lbl = lbl.baseText;
            }
        }

        if (def.placeholderExtension) {
            def.placeholder = extendText(def.placeholder || lbl, def.placeholderExtension);
        }
        if (def.hintExtension) {
            def.hint = extendText(def.hint || lbl, def.hintExtension);
        }

        return inputDef;
    }

    export function extendText(baseText: ObservableOrValueReadonly<string>, ext: TextExtensionDefinition): ObservableOrValueReadonly<string> {
        if (!ext)
            return baseText;
        if (isExtendedTextObservable(baseText) && ext == baseText.extension) {
            return baseText;
        }


        var res = ko.pureComputed(() => {
            var txt: string = "";
            var e = ext;

            txt = getWrappedText(e.prefix, e.prefixWrapMode);

            appendPart(ko.unwrap(baseText));
            appendPart(getWrappedText(e.suffix, e.suffixWrapMode));

            return txt;

            function appendPart(part: string) {
                if (part) {
                    if (txt) txt = txt + " " + part;
                    else txt = part;
                }
            }
        });

        return utils.extend2(res, { baseText: baseText, extension: ext });

        function getWrappedText(txt: ObservableOrValueReadonly<string>, wrapMode: string) {
            txt = ko.unwrap(txt);

            if (!txt || typeof (txt) !== "string") return "";

            if (wrapMode)
                switch (wrapMode) {
                    case "(":
                        txt = "(" + txt + ")";
                        break;
                    case "[":
                        txt = "[" + txt + "]";
                        break;
                }

            return txt;
        }
    }

    function isExtendedTextObservable(txt: any): txt is ExtendedTextObservable {
        if (!ko.isObservable(txt))
            return false;

        return "baseText" in txt && "extension" in txt;
    }

    function setDataSourceOptions<TItem = any, TValue = any>(inputDef: ILookupInputDefinition<DevExpress.ui.dxDropDownListOptions | DevExpress.ui.dxTagBoxOptions, TItem, TValue>, options?: ObservableOrValueModel<DevExpress.ui.dxDropDownListOptions | DevExpress.ui.dxTagBoxOptions>) {

        setOption(options, "valueExpr", inputDef.valueExpr);
        setOption(options, "displayExpr", inputDef.displayExpr || inputDef.valueExpr);
        setOption(options, "acceptCustomValue", inputDef.acceptCustomValue);
        setOption(options, "searchEnabled", inputDef.searchEnabled);

        if (options.dataSource === undefined) {
            let src: DevExpress.data.DataSource = null;

            if (inputDef.items instanceof viewModels.EnumLookup) {
                options.dataSource = inputDef.items.values;

                if (inputDef.filter) {
                    var values = inputDef.items.values;
                    if (ko.isObservable(inputDef.filter)) {
                        options.dataSource = ko.computed(() => {
                            let filter = ko.unwrap(inputDef.filter);
                            if (filter)
                                return values.filter(d => filter.indexOf(d.value) != -1);
                            else
                                return values;
                        })
                    }
                    else {
                        let filter = inputDef.filter;
                        options.dataSource = values.filter(d => filter.indexOf(d.value) != -1);
                    }
                }


                setOption(options, "valueExpr", "value");
                setOption(options, "displayExpr", "displayName");
                setOption(options, "acceptCustomValue", false);
            }
            else if (inputDef.items instanceof viewModels.SearchableDataSource || inputDef.items instanceof viewModels.DialogSearcherViewModelBase) {
                src = inputDef.items.source;
            }
            else if (inputDef.items instanceof viewModels.DataDataSource) {
                //src = inputDef.items.source;

                setOption(options, "items", inputDef.items.allItems);
            }
            else if (inputDef.items instanceof DevExpress.data.DataSource) {
                src = inputDef.items;
            }
            else {
                options.items = inputDef.items as any;

                if (inputDef.predicate) {
                    options.items = ko.pureComputed(() => {
                        var items = ko.unwrap(inputDef.items as any[]);
                        return $.isArray(items) ? items.filter(inputDef.predicate) : null;
                    });

                    if (isLookupCollectionFunctions(inputDef.items)) {
                        let src = inputDef.items as Partial<ILookupCollectionFunctions<TItem>>;
                        let dst = options.items as Partial<ILookupCollectionFunctions<TItem>>;

                        if (src.baseOptions)
                            dst.baseOptions = src.baseOptions;
                        if (src.createCustomItem)
                            dst.createCustomItem = src.createCustomItem;
                        if (src.onEdit)
                            dst.onEdit = src.onEdit;
                    }

                }
            }


            if (src != null) {
                options.dataSource = src;
                setOption(options, "valueExpr", src.key());
                setOption(options, "displayExpr", src.key());
                setOption(options, "acceptCustomValue", false);
            }

        }
    }

    export function getSelectBoxOptions<TItem = any, TValue = string>(inputDef: ILookupInputDefinition<DevExpress.ui.dxSelectBoxOptions, TItem, TValue>, options?: ObservableOrValueModel<DevExpress.ui.dxSelectBoxOptions>, ...emptyFields: string[]) {

        options = getEditorOptionsBase(inputDef, options);

        setDataSourceOptions(inputDef, options);

        if (inputDef.optional !== false)
            options.showClearButton = true;

        if ((inputDef as any).itemTemplate)
            setOption(options, "itemTemplate", (inputDef as any).itemTemplate);

        var btns = ko.unwrap(options.buttons) || [];

        let eh: { (curValue: ObservableOrValue<TValue>): PromiseLike<TValue> } = null;
        if (isLookupCollectionFunctions<TItem, TValue>(inputDef.items) && inputDef.items.onEdit && options.buttons === undefined) {
            eh = inputDef.items.onEdit;
        }
        else if (inputDef.onEdit) {
            eh = inputDef.onEdit
        }
        if (eh) {
            btns.push({
                name: "edit",
                options: {
                    icon: "fa fa-edit",
                    hint: t("view/common/edit"),
                    onClick: () => eh(inputDef.value)
                }
            });

        }

        if (inputDef.buttons)
            inputDef.buttons.forEach(btn => {
                btns.push({
                    name: btn.name,
                    options: {
                        icon: ko.unwrap(btn.icon),
                        hint: ko.unwrap(btn.caption),
                        onClick: e => btn.click()
                    }
                });
            });

        btns.push("dropDown");
        if (options.showClearButton)
            btns.unshift("clear");
        options.buttons = btns;


        options = addSelectBoxOptions(options, ...emptyFields);

        return options;
    }

    export function getTagBoxOptions<TItem = any, TValue = any>(inputDef: ILookupInputDefinition<DevExpress.ui.dxTagBoxOptions, TItem, TValue>, options?: ObservableOrValueModel<DevExpress.ui.dxTagBoxOptions>, ...emptyFields: string[]) {

        options = getEditorOptionsBase(inputDef, options);

        setDataSourceOptions(inputDef, options);

        if (inputDef.optional !== false)
            options.showClearButton = true;

        var btns = ko.unwrap(options.buttons) || [];

        let eh: { (curValue: ObservableOrValue<string>): Promise<string> } = null;
        if (isLookupCollectionFunctions(inputDef.items) && inputDef.items.onEdit && options.buttons === undefined) {
            eh = inputDef.items.onEdit;
        }
        else if ((inputDef as any).onEdit) {
            eh = (inputDef as any).onEdit
        }
        if (eh) {
            btns.push({
                name: "edit",
                options: {
                    icon: "fa fa-edit",
                    hint: t("view/common/edit"),
                    onClick: () => eh(inputDef.value)
                }
            });

            if (inputDef.buttons)
                inputDef.buttons.forEach(btn => {
                    btns.push({
                        name: btn.name,
                        options: {
                            icon: ko.unwrap(btn.icon),
                            hint: ko.unwrap(btn.caption),
                            onClick: e => btn.click()
                        }
                    });
                });

            if (options.showClearButton)
                btns.unshift("clear");

            options.buttons = btns;
        }

        options = addTagBoxOptions(options, ...emptyFields);

        return options;
    }

    export function getLoadPanelOptions(options: ObservableOrValueModel<DevExpress.ui.dxLoadPanelOptions>) {

        if (options.visible !== undefined) {
            var _init = ko.observable(false);
            var _v = options.visible;

            options.visible = ko.computed(() => {

                if (!_init.peek()) {
                    ko.unwrap(_init);
                    return false;
                }
                else
                    return ko.unwrap(_v);

            }).extend({ deferred: true });

            if (options.message === undefined && ko.isObservable(_v) && (_v as unknown as utils.IBusyCounter).title) {
                options.message = (_v as unknown as utils.IBusyCounter).title;
            }

            options.onInitialized = e => _init(true);

        }

        if (options.showIndicator === undefined)
            options.showIndicator = true;

        if (options.shading === undefined)
            options.shading = true;

        if (options.shading && options.shadingColor === undefined)
            options.shadingColor = 'rgba(0,0,0,0.4)';

        return options;
    }

    export function getActionButtonClass(action: IActionDefinition, group?: IActionDefinition) {
        let col: string = ko.unwrap(action.color);

        if (!col && group)
            col = ko.unwrap(group.color);

        if (!col)
            col = "primary";

        return "btn-outline-" + col;
    }
    export function getActionIconName(action: IActionDefinition, group?: IActionDefinition) {
        let n = ko.unwrap(action.icon);

        if (!n && group) {
            if (typeof (group) === "string")
                n = group;
            else
                n = ko.unwrap(group.icon);
        }

        return n;
    }

    // #region EditorControl
    const blockElms = "p|div";
    const blockElmPattern = "(?:</(?:" + blockElms + ")>)(?:(\\s+)?(?:<(?:" + blockElms + ")>))?|(?:<(?:" + blockElms + ")>)|</?br>";

    function normalizeArtTxt(txt: string) {
        // Q> Normalization Logic?

        if (!txt) return txt;

        var txt2 = txt.replace(new RegExp(blockElmPattern, "gi"), (m, g1) => {
            return g1 ? g1 + "\n" : "\n";
        });

        return txt2;
    }

    /** ViewModel for a HTML Editor */
    export class EditorControl {
        parent: any;

        private _initialized = false;
        private data: KnockoutObservable<string>;
        taNode: JQuery;
        editorContainer: JQuery;
        private editorNode: JQuery;
        active: KnockoutObservable<boolean>;
        commandGroups: KnockoutObservableArray<IEditorCommandGroup>;

        static selectionChanged = function () {
            var test = ko.observable();
            utils.equalsIgnoreCase
            setInterval(() => { test.valueHasMutated(); }, 200)

            return test;
        }();

        constructor() {
            var self = this;
            this.active = ko.observable(false);
            this.commandGroups = ko.observableArray();

            this.active.subscribe(function (newValue) {
                if (newValue) {
                    self.placeCaretAtEnd();
                }
                if (this.editorNode) {
                    var ev = newValue ? "cdh.editor.focus" : "cdh.editor.blur";
                    this.editorNode.trigger(ev);
                }
            });

            // TODO Names for Editor Commands
            var commands: IEditorCommand[] = [];

            var cmd: EditorToggleFormatCommand = new EditorToggleFormatCommand("bold", t2("data/articleText/formats.bold"));
            cmd.icon("fa-bold");
            commands.push(cmd);

            cmd = new EditorToggleFormatCommand("italic", t2("data/articleText/formats.italic"));
            cmd.icon("fa-italic");
            commands.push(cmd);

            cmd = new EditorToggleFormatCommand("underline", t2("data/articleText/formats.underline"));
            cmd.icon("fa-underline");
            commands.push(cmd);




            this.commandGroups.push({ displayMode: "buttons", alignment: 0, items: commands });
        }

        getGroupsByAlignment(alignment: number): IEditorCommandGroup[] {
            let res: IEditorCommandGroup[] = [];

            let gArr = ko.unwrap(this.commandGroups);
            gArr.forEach(g => {
                if ($.isArray(g)) g = { items: g };
                if (g) {
                    let a = ko.unwrap(g.alignment) || 0;

                    if (a == alignment)
                        res.push(g);

                }
            });

            res = res.sort((g1, g2) => {
                let x1 = ko.unwrap(g1.order) || 0;
                let x2 = ko.unwrap(g2.order) || 0;

                return x1 - x2;
            });

            return res;
        }

        public async init(textArea: HTMLTextAreaElement) {
            var self = this;

            this.taNode = $(textArea);
            self.taNode.css("display", "none");

            if (!document.getElementById("templates/html-editor/container")) {
                // TODO Display LoadPanel

                await utils.resolveTemplate("templates/html-editor/container");
            }
            let elm = document.createElement("div");
            self.editorContainer = $(elm);
            self.taNode.before(elm);

            ko.applyBindingsToNode(elm, { template: { name: "templates/html-editor/container", data: self } });

            self.editorNode = self.editorContainer.find(".editor");


            self.editorNode.on("blur keyup  input", function () {
                self.updateTextArea();

            }).focusin(function () {
                self.active(true);
            });
            self.editorContainer.focusout(function (evt) {
                var elm = self.editorContainer;

                if (elm.has(document.activeElement).length === 0) {
                    let rt = evt.relatedTarget as Element;

                    if (!rt || (elm.has(rt).length === 0 && !rt.classList.contains("dx-context-menu")))
                        self.active(false);
                }
            });

            self._initialized = true;
            self.updateEditor();


            return self;
        }

        private updateEditor() {
            if (this._initialized)
                this.editorNode.html(this.taNode.text());
        };

        private updateTextArea() {
            if (this.active())
                return;

            var html = this.editorNode.html();
            html = normalizeArtTxt(html);

            this.text(html, true);
        };

        text(value?: string, skipUpdateIfActive?: boolean) {
            if (value === undefined)
                return this.taNode.text();
            else {
                value = this.processText(value);

                this.taNode.text(value);

                if (!(skipUpdateIfActive && this.active()))
                    this.updateEditor();

                if (ko.isWriteableObservable(this.data))
                    this.data(value);
            }
        };

        private processText(text: string): string {
            if (text) {
                text = text.replace(/<stron>/, "<b>");
                text = text.replace(/<\/stron>/, "</b>");
                text = text.replace(/<br>/, "\n");
                text = text.replace(/&nbsp;/, " ");
            }

            return text;
        };

        bind(parent: any, observable: KnockoutObservable<string>) {
            var self = this;
            this.parent = parent;
            this.data = observable;

            if (ko.isSubscribable(observable)) {
                observable.subscribe(function (newValue) {
                    self.text(newValue);
                });
            }

            this.text(ko.unwrap(observable));
        }

        public execCommand(name: string, showUI?: boolean, value?: string) {
            if (this._initialized) {
                this.active(true)

                document.execCommand(name, showUI, value);

                this.editorNode[0].focus();
            }
        }

        public placeCaretAtEnd() {
            if (!this._initialized)
                return;

            var el = this.editorNode[0];

            el.focus();
            if (typeof (window.getSelection) !== "undefined" && typeof document.createRange !== "undefined") {
                var range = document.createRange();
                range.selectNodeContents(el);
                range.collapse(false);
                var sel = window.getSelection();
                sel.removeAllRanges();
                sel.addRange(range);
            } else if (typeof ((document.body as any).createTextRange) !== "undefined") {
                var textRange = (document.body as any).createTextRange();
                textRange.moveToElementText(el);
                textRange.collapse(false);
                textRange.select();
            }
        }
    }

    /** ViewModel for Editor Commands used to Toggle formatting of Text */
    export class EditorToggleFormatCommand implements IEditorCommand {
        readonly displayName: ObservableOrValueReadonly<string>;

        constructor(readonly name: string, displayName?: ObservableOrValueReadonly<string>, readonly tooltip?: ObservableOrValueReadonly<string>) {

            this.displayName = displayName || name;

            if (!tooltip) this.tooltip = this.displayName;
        }

        readonly icon = ko.observable<string>();

        public getState(editor: EditorControl) {
            var res = false;
            if (editor && editor.active()) {
                EditorControl.selectionChanged();
                res = document.queryCommandState(this.name);
            }

            return res;
        }

        public execute(editor: EditorControl) {
            editor.execCommand(this.name);
        }
    }

    /** ViewModel for Editor Commands used to insert Text */
    export class EditorInsertPlaceholderCommand implements IEditorCommand {

        readonly displayName: ObservableOrValueReadonly<string>;

        constructor(readonly name: string, displayName?: ObservableOrValueReadonly<string>, readonly tooltip?: ObservableOrValueReadonly<string>) {

            this.displayName = displayName || name;

            if (!tooltip) this.tooltip = this.displayName;
        }

        public execute(editor: EditorControl) {
            editor.execCommand("insertText", null, this.name + "\n");
        }

        public getState(editor: EditorControl) { return false; }
    }

    // TODO Consolidate Interfaces for EditorCommands and ActionDefinitions

    export interface IEditorCommandGroup {
        name?: string;
        displayName?: ObservableOrValueReadonly<string>;
        tooltip?: ObservableOrValueReadonly<string>;
        icon?: ObservableOrValueReadonly<string>;

        items: ObservableOrValue<IEditorCommand[]>;

        // Q> Control where and how the Elements are displayed?
        displayMode?: ObservableOrValueReadonly<"buttons" | "dropdown">;
        alignment?: ObservableOrValueReadonly<number>;
        order?: ObservableOrValueReadonly<number>;
    }

    /** Interface for an Editor Command */
    export interface IEditorCommand {
        readonly name: string;

        // Q> Name of the Properties?
        icon?: ObservableOrValueReadonly<string>;
        displayName: ObservableOrValueReadonly<string>;
        tooltip?: ObservableOrValueReadonly<string>;

        getState(editor: EditorControl): boolean;
        execute: (editor: EditorControl) => void;
    }

    // #endregion

    // #region Utility for Dialogs

    export class DialogContainer implements IDisposable, IDialogContainerViewModel {

        static defaultSizes: Dictionary<{ height: number | string, width: number | string }> = {
            default: { height: 700, width: 1024 },
            m: { height: 520, width: 720 }
        };
        static applyCustomTitle?: (e: DxWidgetEventArgs<DevExpress.ui.dxPopup, unknown>, options: IDialogOptions) => { showTitle: boolean, node: HTMLElement, container: JQuery };
        static defaultBusyCounter?: utils.IBusyCounter;
        static conventions: IDialogModelConventionFactory[] = [];
        // Q> Add Method/Property for Attaching ModelConventions that can be used to attach behaviours to the Dialog.

        readonly dispose: { (): void };

        constructor(private readonly _isBusy?: utils.IBusyCounter) {
            let loadPanelNode: HTMLDivElement;

            if (!_isBusy) {
                this._isBusy = utils.createBusyCounter();

                loadPanelNode = document.createElement("div");
                document.body.append(loadPanelNode);
                ko.applyBindingsToNode(loadPanelNode, { dxLoadPanel: getLoadPanelOptions({ visible: <any>this._isBusy }) }, this);
            }


            this.dispose = () => {
                if (loadPanelNode) {
                    ko.cleanNode(loadPanelNode);
                    loadPanelNode.remove();
                    loadPanelNode = undefined;

                }

            }
        }

        private async showBase(options: IDialogOptions, model: object, dialogResult: KnockoutObservable<boolean>): Promise<boolean> {
            var visible: KnockoutObservable<boolean> = ko.observable<boolean>(false);
            var showTitle: KnockoutObservable<boolean> = ko.observable<boolean>();

            var conventions: IDialogModelConvention[] = [];
            for (var i = 0; i < DialogContainer.conventions.length; i++) {
                let c = DialogContainer.conventions[i].initConvention(model, options, this);
                if (c)
                    conventions.push(c);
            }

            // Load Template and Prepare Options
            let d = this._isBusy.beginUsing();
            let template: string;
            let popupOptions: PartialObservableOrValueModel<DevExpress.ui.dxPopupOptions>;
            try {
                template = await utils.loadTemplate(options.template);

                popupOptions = {
                    visible: visible,
                    showTitle: showTitle,
                    onShowing: onShowingHandler,
                    onHidden: onHiddenHandler,
                    showCloseButton: true,
                    minWidth: 300,
                    maxWidth: "80%",
                    maxHeight: "80%"
                };

                if (conventions.some(c => c.onShown))
                    popupOptions.onShown = e => {
                        conventions.forEach(c => {
                            if (c.onShown)
                                c.onShown(e);
                        })
                    };

                if (typeof options.title === "string")
                    popupOptions.title = options.title;
                else if (typeof options.title === "function")
                    popupOptions.title = options.title();


                var deferred = $.Deferred<null>()

                // Resolve Dialog Height
                let h = ko.unwrap(options.height);
                let w = ko.unwrap(options.width);
                let s = ko.unwrap(options.size);
                if (s) {
                    if (typeof s == "string") {
                        if (s == "auto")
                            h = w = null;
                        else {
                            let s2 = DialogContainer.defaultSizes[s.toLowerCase()];
                            if (s2) {
                                h = s2.height;
                                w = s2.width;
                            }
                        }
                    }
                    else {
                        h = ko.unwrap(s.height);
                        w = ko.unwrap(s.width);
                    }
                }

                popupOptions.height = h || "auto";
                popupOptions.width = w || "auto";
                popupOptions.resizeEnabled = (typeof (h) === "number");
                if (DevExpress.devices.current().phone) {
                    // Q> Condition for the FullScreen-Mode
                    popupOptions.fullScreen = typeof (w) == "number" && w > 0;
                }
            }
            finally {
                d.dispose();
            }

            // Display Dialog
            let diaNode = document.createElement("div");
            let dArr: IDisposable[] = conventions.slice();
            try {
                document.body.append(diaNode);
                ko.applyBindingsToNode(diaNode, { dxPopup: popupOptions }, this);

                visible(true);

                dArr.push(visible.subscribe(value => {
                    if (value === false) {
                        deferred.resolve();

                        if (options.onClosed)
                            options.onClosed(model);
                    }
                }));

                if (ko.isObservable(dialogResult)) {
                    dialogResult(null);
                    dArr.push(dialogResult.subscribe(value => {
                        if (value !== null && value !== undefined) {
                            visible(false);
                        }
                    }));
                }


                await deferred;
                return ko.unwrap(dialogResult) || false;

            }
            catch (err) {
                console.error("Error displaying Dialog", err);
            }
            finally {
                ko.cleanNode(diaNode);
                diaNode.remove();

                while (dArr.length)
                    dArr.shift().dispose();
            }

            function onShowingHandler(e: DxWidgetEventArgs<DevExpress.ui.dxPopup, unknown>) {

                let c: JQuery<HTMLElement> = e.component.content();
                let node: HTMLElement = c[0];

                if (DialogContainer.applyCustomTitle) {
                    var res = DialogContainer.applyCustomTitle(e, options);
                    showTitle(!res || res.showTitle);
                    if (res && res.node)
                        node = res.node;
                    if (res && res.container)
                        c = res.container;
                }
                else
                    showTitle(true);

                ko.cleanNode(node);

                c.html(template);
                ko.applyBindingsToDescendants(model, node);

                e.component.option("position", "center");
                e.component.repaint();

                for (var i = 0; i < conventions.length; i++) {
                    let c = conventions[i];
                    if (c.onShowing)
                        c.onShowing(e);
                }

            }

            function onHiddenHandler(e: DxWidgetEventArgs<DevExpress.ui.dxPopup, unknown>) {

                e.component.content().html(null);
                var node = e.component.content()[0];

                ko.cleanNode(node)
            }
        }

        public show(options: IDialogOptions, model: object): Promise<any> {
            return this.showBase(options, model, null);
        }

        public showDialog<T extends IDialogViewModel>(options: IDialogOptions, model: T): Promise<boolean> {
            return this.showBase(options, model, model.dialogResult);
        }

        public async showDialogValue<TModel extends IDialogViewModel, TValue>(options: IDialogOptions, model: TModel, valueFunc: (model: TModel) => TValue): Promise<TValue> {
            if (await this.showDialog(options, model))
                return valueFunc(model);
            else
                throw new Error("Dialog Closed?");

        }



    }

    interface IDialogModelConvention extends IDisposable {
        // Q> Parameters
        onShowing?(e: DxWidgetEventArgs<DevExpress.ui.dxPopup, unknown>): void;
        onShown?(e: DxWidgetEventArgs<DevExpress.ui.dxPopup, unknown>): void;
        // Q> Add Events?
    }

    interface IDialogModelConventionFactory {
        /**
         * Initiates a convention if it applies to the model
         * @param model
         * @param options
         * @param popup
         */
        initConvention(model: any, options: IDialogOptions, popup: IDialogContainerViewModel): null | IDialogModelConvention;
    }

    DialogContainer.conventions.push({
        initConvention(model, options, popup) {
            let defBusy = DialogContainer.defaultBusyCounter;
            let modelBusyCounter: utils.IBusyCounter = null;
            if (model && ko.isObservable((model as any).isBusy) && DialogContainer.defaultBusyCounter) {
                modelBusyCounter = (model as any).isBusy;
            }

            if (defBusy && modelBusyCounter) {
                return {
                    onShown: () => defBusy.addDependency(modelBusyCounter),
                    dispose: () => defBusy.removeDependency(modelBusyCounter)
                };
            }
            return null;
        }
    })

    export async function showYesNoCancelDialog(msg: string, title?: string): Promise<boolean> {
        return showYesNoCancelIconDialog(msg, "question", title);
    }

    export async function showYesNoCancelIconDialog(msg: string, icon: alertIcons, title?: string): Promise<boolean> {
        let dia = DevExpress.ui.dialog.custom({
            title: title,
            messageHtml: getMessageWithIcon(msg, icon),
            buttons: [
                { text: t("Yes"), onClick: (e: DxWidgetEventArgs<DevExpress.ui.dxButton, void>) => true },
                { text: t("No"), onClick: (e: DxWidgetEventArgs<DevExpress.ui.dxButton, void>) => false },
                { text: t("Cancel"), onClick: (e: DxWidgetEventArgs<DevExpress.ui.dxButton, void>) => "cancel" }
            ]
        });

        let r: boolean | "cancel" = await dia.show();

        if (r === true || r === false)
            return r;
        else
            throw new Error("cancel");
    }

    export type alertIcons = "info" | "warning" | "error" | "success" | "question";

    function getMessageWithIcon(msg: string, icon: alertIcons): string;
    function getMessageWithIcon(msg: string, icon: string): string;
    function getMessageWithIcon(msg: string, icon: string): string {
        // Q> Processing for msg String?
        // - Convert \n to <br/>
        // - Escape Tags
        // - Create Helper for Message to HTML Conversion
        msg = utils.htmlHelpers.lb2br(msg);

        if (icon) {
            switch (icon as alertIcons) {
                case "info":
                    icon = "fa-info-circle text-info";
                    break;
                case "warning":
                    icon = "fa-exclamation-triangle text-warning";
                    break;
                case "error":
                    icon = "fa-exclamation-triangle text-danger";
                    break;
                case "success":
                    icon = "fa-check-circle text-success";
                    break;
                case "question":
                    icon = "fa-question-circle text-info";
                    break;
            }

            var icoHtml = "<span class=\"fa " + icon + "\"></span> "



            msg = icoHtml + msg;
        }

        return msg;
    }

    export function alertIcon(msg: string, icon: alertIcons, title?: string): Promise<void>;
    export function alertIcon(msg: string, icon: string, title?: string): Promise<void>;
    export function alertIcon(msg: string, icon: string, title?: string): Promise<void> {
        return DevExpress.ui.dialog.alert(getMessageWithIcon(msg, icon), title);
    }

    export function showYesNoDialog(msg: string, title?: string): Promise<boolean> {
        return showYesNoIconDialog(msg, "question", title);
    }

    export function showYesNoIconDialog(msg: string, icon: alertIcons, title?: string) {
        return DevExpress.ui.dialog.confirm(getMessageWithIcon(msg, icon), title);
    }

    /** Appends a (disposable) Dialog to the Body and Returns a ViewModel */
    export function appendDialog(): IDialogContainerViewModel & IDisposable {

        return new DialogContainer(DialogContainer.defaultBusyCounter);
    }

    export async function showPopup(model: object, options: IDialogOptions, popup?: IDialogContainerViewModel) {
        let d: { dispose(): void };

        if (popup == null) {
            let tmp = ui.appendDialog();
            popup = tmp;
            d = tmp;
        }

        try {
            return await popup.show(options, model)
        }
        finally {
            if (d) d.dispose();
        }
    }

    export async function showDialog(model: IDialogViewModel, options: IDialogOptions, popup?: IDialogContainerViewModel) {
        let d: { dispose(): void };

        if (popup == null) {
            let tmp = ui.appendDialog();
            popup = tmp;
            d = tmp;
        }

        try {
            return await popup.showDialog(options, model)
        }
        finally {
            if (d)
                d.dispose();
        }
    }

    export async function showDialogValue<TModel extends IDialogViewModel, TValue>(options: IDialogOptions, model: TModel, valueFunc: (model: TModel) => TValue, popup?: IDialogContainerViewModel): Promise<TValue> {

        if (await showDialog(model, options, popup))
            return valueFunc(model);
        else
            throw new Error(); // Q> Error Message;

    }

    export class ModalViewModel<TModel> implements IDialogViewModel {

        public readonly model = ko.observable<TModel>();
        public readonly dialogResult: KnockoutObservable<boolean>;


        constructor(model: TModel, public options: IDialogOptions, dialogResult?: KnockoutObservable<boolean>) {
            this.model(model);

            this.dialogResult = ko.isObservable(dialogResult) ? dialogResult : ko.observable<boolean>();
        }

        public static showDialog<TModel>(model: TModel, options: IDialogOptions, popup?: IDialogContainerViewModel) {
            var diaVm = new ModalViewModel(model, options);

            return diaVm.showDialog(popup);
        }

        public showDialog(popup?: IDialogContainerViewModel): Promise<boolean> {
            return showDialog(this, this.options, popup);
        }
    }

    // #endregion

    // #region Knockout BindingHandlers
    if (Modernizr.inputtypes.date)
        ko.bindingHandlers.date = {
            init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
                // Register change callbacks to update the model
                // if the control changes.
                ko.utils.registerEventHandler(element, "change", function () {
                    let value = valueAccessor();
                    value(moment(element.value));
                });
            },
            // Update the control whenever the view model changes
            update: function (element, valueAccessor: () => KnockoutDateExtender, allBindingsAccessor, viewModel) {
                let value: moment.Moment = valueAccessor().state().value();

                if (value && value.format && value.isValid)
                    element.value = value.format("YYYY-MM-DD");
                else
                    element.value = "";
            }
        };
    else
        ko.bindingHandlers.date = ko.bindingHandlers.value;

    ko.bindingHandlers.timeSpan = {
        update: function (element, valueAccessor: () => KnockoutTimeSpanExtender, allBindingsAccessor, viewModel) {
            let value: moment.Duration = valueAccessor().state().value();


            let vStr: string | number = "";

            if (value) {
                let g = localization.globalize();

                if (g.formatUnit)
                    vStr = g.formatUnit(value.asSeconds(), "second", { form: "short" });
                else
                    vStr = g.formatNumber(value.asSeconds());
            }
            $(element).text(vStr);
        }
    }

    var _supportsDirectory = ("webkitdirectory" in document.createElement("input")) ? true : false;
    if (DevExpress.devices.current().deviceType != "desktop")
        _supportsDirectory = false;
    export const supportsDirectory = _supportsDirectory;

    ko.bindingHandlers.fileInput = {
        init: function (element: HTMLInputElement, valueAccessor: () => KnockoutObservable<FileList>, allBindingsAccessor, viewModel) {
            // Register change callbacks to update the model
            // if the control changes.
            ko.utils.registerEventHandler(element, "change", function () {
                let value = valueAccessor();
                value(element.files);
            });
        },
        // Update the control whenever the view model changes
        update: function (element: HTMLInputElement, valueAccessor: () => KnockoutObservable<FileList>, allBindingsAccessor, viewModel) {
            let file = ko.unwrap(valueAccessor());

            if (file instanceof FileList) {
                if (element.files !== file)
                    element.files = file;
            }
            else
                element.value = null;

            if (supportsDirectory && allBindingsAccessor.has("fileDir")) {
                var useDir = ko.unwrap(allBindingsAccessor.get("fileDir"));

                if (useDir)
                    element.setAttribute("webkitdirectory", null);
                else
                    element.removeAttribute("webkitdirectory");
            }
        }
    };

    ko.bindingHandlers.langId = {
        init(element: Element, valueAccessor, allBindingsAccessor) {
            let txt = t2(valueAccessor());

            ko.applyBindingsToNode(element, { text: txt });
        }
    }


    ko.bindingHandlers.withProperties = ko.bindingHandlers.let;
    //ko.bindingHandlers.withProperties = {
    //    init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
    //        // Make a modified binding context, with a extra properties, and apply it to descendant elements
    //        var innerBindingContext = bindingContext.extend(valueAccessor);
    //        ko.applyBindingsToDescendants(innerBindingContext, element);

    //        // Also tell KO *not* to bind the descendants itself, otherwise they will be bound twice
    //        return { controlsDescendantBindings: true };
    //    }
    //};

    var getFocusOptions = function (valueAccessor: () => any, allBindingsAccessor: KnockoutAllBindingsAccessor) {
        let focus: KnockoutObservable<any> = valueAccessor();
        let value: any;
        let name: "dxSelectBox" | "dxTextBox" | "dxNumberBox" | "dxDateBox"
        let type: "value" | "with" | "dxWidget";

        if (focus instanceof viewModels.FocusViewModelBase)
            focus = focus.focusedElement;

        if (allBindingsAccessor.has("value")) {
            type = "value";
            value = allBindingsAccessor.get('value');
        }
        else if (allBindingsAccessor.has("with")) {
            type = "with";
            value = allBindingsAccessor.get('with');
        }
        else if (tryGetWidgetOptions("dxSelectBox") || tryGetWidgetOptions("dxTextBox") ||
            tryGetWidgetOptions("dxNumberBox") || tryGetWidgetOptions("dxDateBox")) { }

        return { focus, value, type, name: name };

        function tryGetWidgetOptions(widget: "dxSelectBox" | "dxTextBox" | "dxNumberBox" | "dxDateBox") {
            if (allBindingsAccessor.has(widget)) {
                type = "dxWidget";
                name = widget;
                value = allBindingsAccessor.get(widget).value;

                return true;
            }

            return false;
        }
    }

    function scrollToElement(elm: HTMLElement) { // Q> Add Options for Scrolling and focusing Elements
        // TODO check Offsets for Fixed Elements?

        //elm.scrollIntoView();

        console.log("Scroll to Element", elm);
        document.scrollingElement.scrollTo(0, elm.offsetTop);

    }

    ko.bindingHandlers.focus = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            let o = getFocusOptions(valueAccessor, allBindingsAccessor);

            if (!ko.isWriteableObservable(o.focus) || !o.value)
                return;

            // Register change callbacks to update the model
            // if the control changes.
            $(element).on("focusin", evnt => {
                o.focus(o.value);
            });
        },
        // Update the control whenever the view model changes
        update: function (element: HTMLElement, valueAccessor: () => any, allBindingsAccessor, viewModel, bindingContext) {
            let o = getFocusOptions(valueAccessor, allBindingsAccessor);

            if (!o.value) return;

            if (o.value == ko.unwrap(o.focus) && !cdh.utils.isSameElementOrDescendant(element, document.activeElement)) {

                scrollToElement(element);

                if (o.type === "dxWidget")
                    $(element)[o.name]("focus");
                else
                    element.focus();
            }

        }
    }

    ko.bindingHandlers.scrollTo = {
        update: function (element: HTMLElement, valueAccessor, allBindings) {
            var _value = valueAccessor();
            var _valueUnwrapped = ko.unwrap(_value);
            if (_valueUnwrapped) {
                scrollToElement(element);
            }
        }
    };

    ko.bindingHandlers.scrollTop = {

        update: function (element: HTMLElement, valueAccessor: () => { scroll?: ObservableOrValueReadonly<boolean>, addTriggers?: KnockoutSubscribable<unknown>[] }) {
            var val = valueAccessor() || {};

            // Add Dependencies for additional Triggers
            if ($.isArray(val.addTriggers))
                val.addTriggers.forEach(t => ko.unwrap(t));

            if (ko.unwrap(val.scroll) !== false) {

                scrollToElement(element);

            }

        }

    }


    ko.bindingHandlers.editor = {
        init: function (element: Element, valueAccessor, allBindings, viewModel, bindingContext) {
            var ta: HTMLTextAreaElement;

            if (element.tagName == "TEXTAREA")
                ta = <HTMLTextAreaElement>element;
            else {
                ko.virtualElements.insertAfter(element, ta = document.createElement("textarea"), null);
            }

            var ec = new EditorControl();
            ko.utils.domData.set(ta, "editor", ec);

            var ctrl: IEditorCommandGroup[] = allBindings.get("editorControls");

            ec.init(ta).then(editor => {
                var cBc = bindingContext.createChildContext(editor);

                if (ctrl) {
                    editor.commandGroups.push(...ctrl);
                }

                editor.bind(viewModel, valueAccessor());

            });

            return { controlsDescendantBindings: true };
        }
    }

    ko.bindingHandlers.valueOneWayToSource = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {

            var newValue = ko.pureComputed({
                read: function () {
                    return element.value;
                },
                write: function (value) {
                    valueAccessor()(value);
                }
            });

            newValue(newValue());

            ko.applyBindingsToNode(element, {
                textInput: newValue
            }, bindingContext);
        }
    };

    ko.bindingHandlers.lazyContent = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            let v: string | { url: ObservableOrValue<string>, content?: ObservableOrValue<string>, load?: boolean } = ko.unwrap(valueAccessor());


            if (typeof v === "string")
                v = { url: v };

            let cl = ContentLoader.getLoader(element, ko.unwrap(v.content), v.url);

            if (cl != null) {

                var cBc = bindingContext.createChildContext(cl);

                if (ko.unwrap(v.load))
                    cl.loadContent(true);

                ko.applyBindingsToDescendants(cBc, element);

                return { controlsDescendantBindings: true };
            }
        }
    }

    ko.bindingHandlers.allowBindings = {
        init: function (elem, valueAccessor) {
            var shouldAllowBindings = ko.unwrap(valueAccessor());
            return { controlsDescendantBindings: !shouldAllowBindings };
        }
    };

    ko.bindingHandlers.foreachProp = {
        transformObject: function <T>(obj: T) {
            var properties: { key: keyof T, value: T[keyof T] }[] = [];
            if (obj != null)
                ko.utils.objectForEach(obj, function (key, value) {
                    properties.push({ key: key, value: value });
                });
            return properties;
        },
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            var properties = ko.pureComputed(function () {
                var obj = ko.unwrap(valueAccessor());
                return ko.bindingHandlers.foreachProp.transformObject(obj);
            });
            ko.applyBindingsToNode(element, { foreach: properties }, bindingContext);
            return { controlsDescendantBindings: true };
        }
    };

    ko.bindingHandlers.commands = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            var handler: ObservableOrValue<ICommandManager<any>> = valueAccessor();

            if (handler != null)
                handleCommandBase($(element), handler);
        }
    }

    const iconBaseUrl = Router.baseUrl + "Content/svg/symbols.svg#";

    var updateIcon = function (element: HTMLElement, valueAccessor: { (): ObservableOrValue<string> }) {

        var icon = ko.unwrap(valueAccessor());

        var svg: SVGSVGElement;

        if (element.tagName == "svg")
            svg = <SVGSVGElement><any>element;
        else {
            svg = <SVGSVGElement><any>$(element).children("svg")[0];

            if (!svg) {
                svg = document.createElementNS('http://www.w3.org/2000/svg', 'svg');

                element.appendChild(svg);
            }
        }

        $(svg).empty();


        if (icon) {
            var url = iconBaseUrl + icon;

            var useElm = document.createElementNS('http://www.w3.org/2000/svg', 'use');

            useElm.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', url);

            svg.appendChild(useElm);
        }

    }

    // Todo Replace icon Handler with icon2 Handler

    ko.bindingHandlers.icon = {
        update: updateIcon
    }

    type iconType = "fa" | "ico" | "txt" | "none";
    type iconInfo = {
        type: iconType;
        size: number;
        color: string;
        displayClass?: string;
        curElmOuter?: Element;
        curElmInner?: Element;
    };

    ko.bindingHandlers.icon2 = new class IconBindingHandler implements KnockoutBindingHandler<Element> {

        init(elm: Element, valueAccessor: () => ObservableOrValue<string> | [ObservableOrValue<string>, number?, string?], allBindings: KnockoutAllBindingsAccessor) {
            var iconInfo: iconInfo = { type: "none", size: 1, color: '' };

            var c = elm.firstElementChild;
            if (c) {
                c.classList.forEach(cl => {
                    if (utils.startsWithIgnoreCase(cl, "ico-")) {
                        var tmp = cl.substr(4);
                        var i = parseInt(tmp);
                        if (!isNaN(i))
                            iconInfo.size = i;
                        else
                            iconInfo.color = tmp;
                    }
                    else if (utils.startsWithIgnoreCase(cl, "text-")) {
                        var tmp = cl.substr(5);
                        iconInfo.color = tmp;
                    }
                    else if ((utils.startsWithIgnoreCase(cl, "d-"))) {
                        iconInfo.displayClass = cl;
                    }
                })

                switch (c.tagName) {
                    case "svg": {
                        iconInfo.curElmOuter = c;
                        iconInfo.curElmInner = c.getElementsByTagName("use")[0]
                        iconInfo.type = "ico";
                        break;
                    }
                    case "div": {
                        iconInfo.curElmOuter = c;
                        iconInfo.curElmInner = c.firstElementChild;
                        iconInfo.type = "fa";
                        break;
                    }
                }
            }

            if (allBindings.has("iconOptions")) {
                let options = allBindings.get("iconOptions");
                if (options && typeof options == "object") {
                    if (options.size !== undefined && (typeof options.size == "number" && !isNaN(options.size) || options.size == null))
                        iconInfo.size = options.size;
                    if (options.color !== undefined && (typeof options.color == "string" || options.color == null))
                        iconInfo.color = options.color;
                }
            }

            var val = valueAccessor();
            if ($.isArray(val)) {
                if (val[1] > 0)
                    iconInfo.size = val[1];
                if (val[2])
                    iconInfo.color = val[2];
            }


            ko.utils.domData.set(elm, "iconInfo", iconInfo);

            return { controlsDescendantBindings: true };
        }
        update(elm: Element, valueAccessor: () => ObservableOrValue<string> | [ObservableOrValue<string>, number?, string?]) {
            var iconInfo: iconInfo = ko.utils.domData.get(elm, "iconInfo");

            var name = ko.unwrap(valueAccessor());
            if ($.isArray(name)) name = ko.unwrap(name[0]);

            var type: iconType = "none";
            if (typeof name != "string" || name == "") {

            }
            else if (utils.startsWithIgnoreCase(name, "ico-")) {
                type = "ico";
            }
            else if (utils.startsWithIgnoreCase(name, "txt-")) {
                type = "txt";
                name = name.substr(4).toUpperCase();
            }
            else if (utils.startsWithIgnoreCase(name, "fa")) {
                type = "fa";
                switch (name.charAt(2)) {
                    case " ":
                        name = name.substr(3);
                        break;
                    case "-":
                        break;
                    default:
                        type = "none";
                        break;
                }
            }

            this.setIconType(elm, iconInfo, type);

            this.updateIcon(iconInfo, name);
        }
        updateIcon(iconInfo: iconInfo, name: string): any {
            var elm = iconInfo.curElmInner;
            if (iconInfo.curElmOuter)
                switch (iconInfo.type) {
                    case "fa":
                        {
                            var classes: string[] = [];
                            elm.classList.forEach(cn => {
                                if (utils.startsWithIgnoreCase(cn, "fa-"))
                                    classes.push(cn);
                            });
                            elm.classList.remove(...classes);
                            elm.classList.add(name);
                        }
                        break;
                    case "txt":
                        elm.textContent = name;
                        break;
                    case "ico":
                        if (elm.tagName == "use") {
                            var url = iconBaseUrl + name;
                            elm.setAttributeNS('http://www.w3.org/1999/xlink', 'xlink:href', url);
                        }
                }
        }

        setIconType(elm: Element, iconInfo: iconInfo, type: "fa" | "ico" | "txt" | "none"): any {
            if (!utils.equalsIgnoreCase(iconInfo.type, type)) {
                ko.virtualElements.emptyNode(elm);

                iconInfo.type = "none";
                iconInfo.curElmOuter = null;
                iconInfo.curElmInner = null;
            }

            switch (type) {
                case "fa": {
                    if (!iconInfo.curElmOuter) {
                        let c = document.createElement("div");
                        if (iconInfo.size)
                            c.classList.add("ico", "ico-" + iconInfo.size)
                        if (iconInfo.color)
                            c.classList.add("text-" + iconInfo.color);
                        if (iconInfo.displayClass)
                            c.classList.add(iconInfo.displayClass);

                        iconInfo.curElmOuter = c;
                        iconInfo.curElmInner = null;
                        elm.appendChild(c);
                    }
                    if (!iconInfo.curElmInner) {
                        let c2 = document.createElement("div");
                        c2.classList.add("fa");

                        iconInfo.curElmInner = c2;
                        iconInfo.curElmOuter.appendChild(c2);
                    }

                    iconInfo.type = "fa";
                    break;
                }
                case "txt": {
                    if (!iconInfo.curElmOuter) {
                        let c = document.createElement("div");
                        if (iconInfo.size)
                            c.classList.add("ico", "ico-" + iconInfo.size)
                        if (iconInfo.color)
                            c.classList.add("text-" + iconInfo.color);
                        if (iconInfo.displayClass)
                            c.classList.add(iconInfo.displayClass);

                        iconInfo.curElmOuter = c;
                        iconInfo.curElmInner = null;
                        elm.appendChild(c);
                    }
                    if (!iconInfo.curElmInner) {
                        let c2 = document.createElement("div");
                        c2.classList.add("ico-text");

                        iconInfo.curElmInner = c2;
                        iconInfo.curElmOuter.appendChild(c2);
                    }

                    iconInfo.type = "txt";
                    break;
                }
                case "ico": {
                    if (!iconInfo.curElmOuter) {
                        let c = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
                        if (iconInfo.size)
                            c.classList.add("ico", "ico-" + iconInfo.size)
                        if (iconInfo.color)
                            c.classList.add("ico-" + iconInfo.color);
                        if (iconInfo.displayClass)
                            c.classList.add(iconInfo.displayClass);
                        elm.appendChild(c);

                        iconInfo.curElmOuter = c;
                        iconInfo.curElmInner = null;
                        elm.appendChild(c);
                    }

                    if (!iconInfo.curElmInner) {
                        iconInfo.curElmInner = elm = document.createElementNS('http://www.w3.org/2000/svg', 'use');
                        iconInfo.curElmOuter.appendChild(elm);
                    }

                    iconInfo.type = "ico";
                    break;
                }
                default:
                    iconInfo.type = "none";
                    iconInfo.curElmOuter = null;
                    iconInfo.curElmInner = null;
                    break;
            }
        }

        getHandler(): KnockoutBindingHandler {
            return {
                init: this.init.bind(this),
                update: this.update.bind(this)
            };
        }
    }().getHandler();

    ko.bindingHandlers.collapse = {

        init: function (element: HTMLElement, valueAccessor: { (): ObservableOrValue<string> }) {

            var val = ko.unwrap(valueAccessor());

            var $elm = $(element);

            $elm.addClass("collapse");

            if (typeof (val) === "boolean")
                $elm.toggleClass("show", val);
        },
        update: function (element: HTMLElement, valueAccessor: { (): ObservableOrValue<string> }) {
            const domDataKey = "_collapse_timeout";
            var th = ko.utils.domData.get(element, domDataKey);

            if (th) {
                ko.unwrap(valueAccessor());
                return;
            }


            setCollapse();

            return;

            function setCollapse() {
                ko.utils.domData.set(element, domDataKey, undefined);
                var val = ko.unwrap(valueAccessor());

                if (element.classList.contains("collapsing")) {
                    let th = setTimeout(setCollapse, 50);
                    ko.utils.domData.set(element, domDataKey, th);
                }
                else {

                    if (typeof (val) === "boolean")
                        val = val ? "hide" : "show";

                    (<any>$(element)).collapse(val);
                }


            }
        }
    }

    ko.bindingHandlers.img = {

        init(imgElm: HTMLImageElement, valueAccessor: () => ObservableOrValue<string>, allBindings) {

            var res: KnockoutObservable<boolean> = allBindings.get("imgState");
            if (!ko.isWriteableObservable(res))
                res = null;

            imgElm.onload = e => {
                imgElm.classList.remove("d-none");
                if (res) res(true);
            }
            imgElm.onerror = e => {
                imgElm.classList.add("d-none");
                if (res) res(false);
            }

            return { controlsDescendantBindings: true };
        },

        update(imgElm: HTMLImageElement, valueAccessor: () => ObservableOrValue<string>, allBindings) {
            var url = ko.unwrap(valueAccessor());

            imgElm.classList.add("d-none");
            if (url && typeof (url) == "string")
                imgElm.src = url;
            else {
                delete imgElm.src;
                var res: KnockoutObservable<boolean> = allBindings.get("imgState");
                if (ko.isWriteableObservable(res))
                    res(false);
            }

        }
    }

    ko.bindingHandlers.width = <KnockoutBindingHandler<Element, number>>{
        update: function (element: Element, valueAccessor) {
            var val = ko.unwrap(valueAccessor());

            if (typeof val === "number" && val > 0)
                $(element).outerWidth(val);

        }
    }

    export type sizeBreakpointDefinition = {
        min?: number;
        max?: number;
        name: string;
    }
    export type sizeBreakpointGroup = {
        name?: string;
        classPrefix?: string;

        type?: "width" | "height";
        points: sizeBreakpointDefinition[];
    };

    function getBreakpoint(elm: HTMLElement, group: sizeBreakpointGroup): string {

        var size: number = 0;
        if (!group.type || utils.equalsIgnoreCase(group.type, "width"))
            size = elm.clientWidth;
        else if (utils.equalsIgnoreCase(group.type, "height"))
            size = elm.clientHeight;

        let result: string = null;

        for (var i = 0; i < group.points.length; i++) {
            var p = group.points[i];
            let isValid = true;

            if (p.min != null && !(size >= p.min))
                isValid = false;
            if (p.max != null && !(size <= p.max))
                isValid = false;

            if (isValid) result = p.name;
        }

        return result;
    }

    export const breakpoints: Dictionary<sizeBreakpointGroup | sizeBreakpointGroup[]> = {};

    ko.virtualElements.allowedBindings["breakpoints"] = true;
    ko.bindingHandlers.breakpoints = {
        init(node: Node, valueAccessor: () => (sizeBreakpointGroup | string) | (sizeBreakpointGroup | string)[], allBindings, vm: any, ctx) {

            var elm = node.nodeType == Node.ELEMENT_NODE ? node as HTMLElement : node.parentElement;
            var val = valueAccessor();

            if (!val) return; // Q> Add Default Breakpoints

            let valArr = $.map($.isArray(val) ? val : [val], v => {
                if (!v) return null;
                else if (typeof (v) == "string")
                    return breakpoints[v] || null;
                else
                    return v;
            });


            var ext: Dictionary<KnockoutObservable<string>> = {};
            var tmp: { points: sizeBreakpointGroup, obs: KnockoutObservable<string> }[] = [];

            valArr.forEach(group => {
                var type = group.type || "width";
                var name = group.name || (type + "Breakpoint");

                if (!name || ext[name])
                    return;

                var obs = ko.observable<string>().extend({ deferred: true });

                ext[name] = obs;
                tmp.push({ points: group, obs: obs });


            });

            updateGroups();
            if (ResizeObserver) {
                let updAction = new utils.DelayedAction(updateGroups, 250);
                var ro = new ResizeObserver(() => updAction.schedule());


                ro.observe(elm);

                ko.utils.domNodeDisposal.addDisposeCallback(node, () => {
                    ro.disconnect();
                    updAction.cancel();
                });
            }
            // TODO Add Alternative to ResizeObserver?

            ctx = ctx.extend(ext);
            ko.applyBindingsToDescendants(ctx, node);
            return { controlsDescendantBindings: true };

            function updateGroups() {
                for (var i = 0; i < tmp.length; i++) {
                    let { points, obs } = tmp[i];

                    let bp = getBreakpoint(elm, points);

                    let oldVal = obs.peek();
                    if (oldVal != bp) {
                        obs(bp);

                        if (points.classPrefix) {
                            if (oldVal)
                                elm.classList.remove(points.classPrefix + "-" + oldVal);
                            if (bp)
                                elm.classList.add(points.classPrefix + "-" + bp);
                        }

                    }
                }

            }

        }
    }

    export interface IResponsiveDrawerDefinition {
        collapse?: ObservableOrValueReadonly<boolean>;
        breakpoints?: { name: string, values: string[], invert?: boolean }
        position?: "left" | "right";

        menuName?: string;
        menuId?: string;

        contentName?: string;
        contentId?: string;

    }
    interface ResponsiveDrawerContext {
        readonly isOpen: KnockoutObservable<boolean>
        readonly isCollapsed: ObservableOrValueReadonly<boolean>

        isCollapsedOld?: boolean;
    }

    class ResponsiveDrawerBindingHandler implements KnockoutBindingHandler<HTMLDivElement, IResponsiveDrawerDefinition>{

        init(elm: HTMLDivElement, valueAccessor: () => IResponsiveDrawerDefinition, allBindings: KnockoutAllBindingsAccessor, vm: any, bCtx: KnockoutBindingContext) {
            var val = valueAccessor();

            var ctx = this.getContext(elm, val);
            var o = this.getOptions(val, elm, ctx, bCtx);

            var cnt = document.createElement("div");
            cnt.setAttribute("data-bind", "dxDrawer: $context.drawer.options");

            while (elm.childNodes.length) {
                var n = elm.childNodes[0];

                cnt.appendChild(n);
            }

            elm.appendChild(cnt);

            bCtx = bCtx.extend({
                drawer: {
                    isOpen: ctx.isOpen,
                    collapse: ctx.isCollapsed,
                    options: o
                }
            });

            //ko.applyBindingsToNode(elm, { dxDrawer: o }, bCtx);
            ko.applyBindingsToDescendants(bCtx, elm);
            return { controlsDescendantBindings: true };
        }

        update(elm: HTMLDivElement, valueAccessor: () => IResponsiveDrawerDefinition) {

            var instance = DevExpress.ui.dxDrawer.getInstance(elm) || DevExpress.ui.dxDrawer.getInstance(elm.firstElementChild);

            if (!instance) {
                throw new Error("No Instance Found");
            }

            var val = valueAccessor();
            var ctx = this.getContext(elm, val);
            var o = this.updatePositionOptions(null, val, ctx);

            instance.option(o);

            setTimeout(() => instance.option("opened", o.opened), 5);
        }

        getContext(elm: HTMLDivElement, def: IResponsiveDrawerDefinition): ResponsiveDrawerContext {
            var ctx: ResponsiveDrawerContext = ko.utils.domData.get(elm, "_respDrwrCtx");
            if (!ctx) {
                var isColl: ObservableOrValueReadonly<boolean> = null;
                var isOpen: KnockoutObservable<boolean> = null;

                if (def) {
                    if (ko.isObservable(def.collapse) || typeof (def) == "boolean")
                        isColl = def.collapse;
                    else if (def.breakpoints) {
                        let bp = def.breakpoints;
                        isColl = ko.pureComputed(() => {
                            var ctx = ko.contextFor(elm);
                            var isMatch = false;

                            if (ctx && bp.name in ctx) {
                                let val: string = ko.unwrap(ctx[bp.name]);

                                if (typeof (val) == "string" && bp.values)
                                    for (var i = 0; i < bp.values.length; i++) {
                                        if (utils.equalsIgnoreCase(val, bp.values[i])) {
                                            isMatch = true;
                                            break;
                                        }
                                    }

                            }

                            if (bp.invert) isMatch = !isMatch;

                            return !isMatch;
                        });
                    }
                }

                if (isColl == null) isColl = false;
                if (isOpen == null) isOpen = ko.observable(!ko.unwrap(isColl));


                ctx = { isOpen: isOpen, isCollapsed: isColl };
                ko.utils.domData.set(elm, "_respDrwrCtx", ctx);
            }
            return ctx;
        }

        getOptions(val: IResponsiveDrawerDefinition, cnt: HTMLDivElement, ctx: ResponsiveDrawerContext, bCtx: KnockoutBindingContext): ObservableOrValueModel<DevExpress.ui.dxDrawerOptions> {
            let o: ObservableOrValueModel<DevExpress.ui.dxDrawerOptions> = {};



            o.onInitialized = e => {
                let cmp = e.component;

                setTimeout(() => (cmp as any).resizeContent(), 100);

                e.component.on("optionChanged", (c: { name: string, value: any }) => {
                    if (utils.equalsIgnoreCase(c.name, "opened"))
                        setTimeout(() => {
                            ctx.isOpen(cmp.option("opened"));
                        }, 100);
                });


            }

            var name = val.contentName || "content";
            copyTemplate(val.contentId, name);

            name = val.menuName || "menu";
            o.template = name;
            copyTemplate(val.menuId, name);

            this.updatePositionOptions(o, val, ctx);

            return o;

            function copyTemplate(id: string, name: string) {
                if (id && name) {
                    var elm = document.getElementById(id);
                    if (elm) {
                        var cpElm = elm.cloneNode(true) as Element;
                        cpElm.id = null;

                        cpElm.setAttribute("data-options", "dxTemplate: {name: '" + name + "'}");

                        cnt.appendChild(cpElm);

                    }
                }
            }
        }

        updatePositionOptions(o: ObservableOrValueModel<DevExpress.ui.dxDrawerOptions>, val: IResponsiveDrawerDefinition, ctx: ResponsiveDrawerContext): ObservableOrValueModel<DevExpress.ui.dxDrawerOptions> {
            if (!o) o = {};
            if (!val) val = { collapse: true };

            o.position = ko.unwrap(val.position) || o.position;
            if (!o.position)
                o.position = "left";

            var coll = ko.unwrap(ctx.isCollapsed);

            o.revealMode = "slide";
            if (coll != ctx.isCollapsedOld) {
                if (coll) {
                    o.openedStateMode = "overlap";
                    o.closeOnOutsideClick = true;

                    ctx.isOpen(false);
                }
                else {
                    o.openedStateMode = "shrink";
                    o.closeOnOutsideClick = false;

                    ctx.isOpen(true);
                }

                ctx.isCollapsedOld = coll;
            }

            o.opened = ko.unwrap(ctx.isOpen);



            return o;
        }

        getHandler(): KnockoutBindingHandler {
            return {
                init: this.init.bind(this),
                update: this.update.bind(this)
            }
        }

    }

    ko.bindingHandlers.responsiveDrawer = new ResponsiveDrawerBindingHandler().getHandler();


    // Bindinghandlers for JQueryUI
    if (jQuery.ui) {

        ko.bindingHandlers.resizable = {
            update: function (element: HTMLElement, valueAccessor: { (): ObservableOrValue<JQueryUI.ResizableOptions> }, allBindings) {

                var val: JQueryUI.ResizableOptions = ko.unwrap(valueAccessor());
                var $elm = $(element);
                if (allBindings.has("resize-width")) {

                    val = val || {};

                    var width = allBindings.get("resize-width");
                    var curWidth = ko.unwrap(width)

                    if (typeof (curWidth) === "number" && curWidth > 0)
                        $elm.outerWidth(curWidth);

                    if (ko.isWriteableObservable(width))
                        val.resize = (e, u) => width(u.size.width);

                }

                $elm.resizable(val);
            }
        }

        ko.bindingHandlers.draggable = {
            update: function (element: HTMLElement, valueAccessor: { (): ObservableOrValue<JQueryUI.DraggableOptions> }, allBindings) {

                var val = ko.unwrap(valueAccessor());

                $(element).draggable(val);
            }
        }

        ko.bindingHandlers.droppable = {
            update: function (element: HTMLElement, valueAccessor: { (): ObservableOrValue<JQueryUI.DroppableOptions> }, allBindings) {

                var val = ko.unwrap(valueAccessor());

                $(element).droppable(val);
            }
        }

        ko.bindingHandlers.sortable = {
            update: function (element: HTMLElement, valueAccessor: { (): ObservableOrValue<JQueryUI.SortableOptions> }, allBindings) {

                var val = ko.unwrap(valueAccessor());

                $(element).sortable(val);
            }
        }
    }

    ko.bindingHandlers.on = <KnockoutBindingHandler<Element, [string, any?, any?, any?]>>{
        init: function (element, valueAccessor) {
            $(element).on(...valueAccessor());
        }
    }
    ko.bindingHandlers.on2 = <KnockoutBindingHandler<Element, [string, any?, any?, any?][]>>{
        init: function (element, valueAccessor) {
            let $elm = $(element)
            valueAccessor().forEach(eventReg => $elm.on(...eventReg));
        }
    }

    export interface ClickEditOptions<T = string> {
        // TODO Edit Options

        label?: ObservableOrValue<string>;
        value: KnockoutObservable<T>;
        enable?: ObservableOrValue<boolean>;

        focus: "default" | "owner" | "editor";
        appendTo?: string;
        position?: any;
    };

    export interface ClickEditorValueContext<T = string> {
        id?: string;
        label?: ObservableOrValue<string>;

        // TODO Formatting...
        required?: boolean;
        format?: DevExpress.ui.format;
        precision?: number;


        min?: ObservableOrValue<T>;
        max?: ObservableOrValue<T>;
        step?: ObservableOrValue<T>;


        read: () => T;
        write: (val: T) => void;

    }

    export interface ClickEditorContext {
        readonly ctx2: ClickEditorBindingContext; // Q> Name?

        readonly onDisplayed: { (): void }[];
        readonly onRemove: { (): void }[];


        remove(): void;
        displayed(): void;
    };

    export interface ClickEditorBindingContext {
        isEditing: boolean;
        ctx?: ClickEditorContext;

        owner?: JQuery<Element>;
        activate?: () => void;
    }

    export class ClickEditorContextImp {
        constructor(public readonly ctx2: ClickEditorBindingContext) {

        }

        readonly onDisplayed: { (): void }[] = [];
        readonly onRemove: { (): void }[] = [];

        private static callAll(args: { (): void }[]) {
            for (var i = 0; i < args.length; i++) {
                args[i]();
            }
        }

        public displayed(): void {
            if (!this.ctx2.isEditing) {
                this.ctx2.isEditing = true;
                this.ctx2.ctx = this;

                ClickEditorContextImp.callAll(this.onDisplayed);
            }

        }

        public remove(): void {
            if (this.ctx2.ctx == this) {
                this.ctx2.isEditing = false;
                this.ctx2.ctx = null;

                ClickEditorContextImp.callAll(this.onRemove);
            }
        }

    }


    export abstract class ClickEditBindingHandlerBase<T, TOptions extends ClickEditOptions<T> = ClickEditOptions<T>> implements KnockoutBindingHandler<Node, KnockoutObservable<T> | ObservableOrValue<ClickEditOptions<T>>>{
        getOptions(valueAccessor: { (): KnockoutObservable<T> | ObservableOrValue<TOptions> }, ctx: KnockoutBindingContext): TOptions {
            var raw = valueAccessor();

            if (ko.isObservable(raw)) {
                var pVal: any = raw.peek();
                if (pVal != null && typeof (pVal) === "object" && ko.isObservable(pVal.value))
                    raw = <any>pVal;
                else {
                    raw = <any>{ value: raw };
                }
            }

            if (raw == null)
                throw new Error("Options required");

            if (typeof (raw) === "object") {
                if (!ko.isWriteableObservable(raw.value))
                    throw new Error("options.value needs to be writable");

                if (raw.enable == null && (<any>raw).disable != null) {
                    var disable: ObservableOrValue<boolean> = (<any>raw).disable;
                    if (ko.isObservable(disable))
                        raw.enable = ko.pureComputed(() => ko.unwrap(disable) !== true);
                    else
                        raw.enable = disable !== true;
                }


                return raw;
            };

            throw new Error("invalid Options");
        }

        static getEditorValueContext<T>(obs: KnockoutObservable<T>, label?: ObservableOrValue<string>): ClickEditorValueContext<T> {
            if (!ko.isWriteableObservable(obs))
                throw new Error("`obs` needs to be an writeable observable");

            return {
                id: getUniqueId(obs),

                read: obs,
                write: obs,
                label
            }

        }

        activateEditor(ctx2: ClickEditorBindingContext, element: Element, options: TOptions) {

            if (ko.unwrap(options.enable) == false) return;

            if (ctx2.isEditing) return;

            var elm = $(element);

            var obs = options.value;

            var ctx: ClickEditorContext = new ClickEditorContextImp(ctx2);

            var cnt = this.getEditor(options, ctx);

            if (cnt == null) return;

            if (options.appendTo)
                elm = elm.closest(options.appendTo);

            ctx.onRemove.unshift(() => cnt.remove());
            elm.append(cnt);

            ctx.displayed();
        }

        protected createEditorContainer(ctx: ClickEditorContext, options: ClickEditOptions<any>) {
            var cnt = $("<div></div>");
            cnt.addClass("floating-editor");
            if (options.position)
                cnt.addClass("floating-editor-" + options.position);

            cnt.on("focusout", evnt => {

                if (!document.hasFocus()) return;

                if (utils.isSameElementOrDescendant(cnt[0], <any>evnt.relatedTarget))
                    return;

                if (ctx.ctx2.owner && utils.isSameElementOrDescendant(ctx.ctx2.owner[0], <any>evnt.relatedTarget))
                    return;

                ctx.remove();

            });

            ctx.onDisplayed.push(() => cnt.find("input").first().focus());

            return cnt;
        }
        protected createLabel(text: string, id: string): any {
            var label = $("<label></label>");

            label.attr("for", id);

            ko.applyBindingsToNode(label[0], { text: text });

            return label;
        }

        abstract getEditor(options: TOptions, ctx: ClickEditorContext): JQuery;


        getTextEditor(valCtx: ClickEditorValueContext<string>, ctx: ClickEditorContext, setFocus?: boolean): JQuery {

            var val: string = null;
            if (valCtx.read) val = valCtx.read();

            var editor = $("<input type='text'/>");
            editor[0].id = valCtx.id;
            editor.val(val);

            ctx.onRemove.unshift(() => valCtx.write(<string>editor.val()));

            editor.on("keyup", e => {
                if (e.which == 13)
                    ctx.remove();
            });


            if (setFocus !== false)
                ctx.onDisplayed.push(() => editor.focus());

            return editor;
        }

        getNumberEditor2(valCtx: ClickEditorValueContext<number>, ctx: ClickEditorContext, setFocus?: boolean): JQuery {

            var val: number = null;
            if (valCtx.read) val = valCtx.read();

            var editor = $("<input type='number'/>");
            editor[0].id = valCtx.id;
            editor.val(val);

            ctx.onRemove.unshift(() => {
                var val2 = <number>editor.val();
                if (val2 && typeof val2 !== "number")
                    val2 = parseFloat(val2);

                valCtx.write(val2);
            });

            editor.on("keyup", e => {
                if (e.which == 13)
                    ctx.remove();
            });

            if (setFocus !== false)
                ctx.onDisplayed.push(() => editor.focus());

            return editor;
        }

        getNumberEditor(valCtx: ClickEditorValueContext<number>, ctx: ClickEditorContext, setFocus?: boolean): JQuery {

            var tmpObs = ko.observable<number>();
            var inputDef: INumberInputDefinition = {
                id: valCtx.id,
                value: tmpObs,
                label: valCtx.label,
                optional: valCtx.required !== false
            };

            if (valCtx.precision)
                inputDef.precision = valCtx.precision;
            if (valCtx.format)
                inputDef.format = valCtx.format;
            if (valCtx.min)
                inputDef.min = valCtx.min;
            if (valCtx.max)
                inputDef.max = valCtx.max;
            if (valCtx.step)
                inputDef.step = valCtx.step;

            var options = cdh.ui.getNumberBoxOptions(inputDef);

            var val: number = null;
            if (valCtx.read) val = valCtx.read();
            if (typeof val == "number" && !isNaN(val))
                tmpObs(val);

            if (setFocus !== false) {
                options.onContentReady = e => e.component.focus();
            }
            options.onEnterKey = e => ctx.remove();

            ctx.onRemove.unshift(() => {
                var val2: number = ko.unwrap(tmpObs);
                if (typeof val2 != "number" || isNaN(val))
                    val2 = null;

                valCtx.write(val2);
            });

            var editor = $("<div></div>");

            ctx.onDisplayed.push(() => {
                ko.applyBindingsToNode(editor[0], { dxNumberBox: options });
            });

            return editor;
        }

        getDateEditor(valCtx: ClickEditorValueContext<moment.Moment>, ctx: ClickEditorContext, setFocus?: boolean): JQuery {

            var tmpObs = ko.observable<Date>();
            var inputDef: IInputDefinition<Date, DevExpress.ui.dxDateBoxOptions> = {
                id: valCtx.id,
                value: tmpObs,
                label: valCtx.label,
                optional: valCtx.required !== false
            };

            var options = cdh.ui.getEditorOptionsBase(inputDef);

            var valM: moment.Moment = null;
            if (valCtx.read) valM = valCtx.read();
            if (moment.isMoment(valM) && valM.isValid())
                tmpObs(valM.toDate());

            if (setFocus !== false) {
                options.onContentReady = e => {
                    e.component.focus();
                    e.component.open();
                };
            }
            options.onEnterKey = e => ctx.remove();

            ctx.onRemove.unshift(() => {
                var val2M: moment.Moment = null;
                var val2: Date = ko.unwrap(tmpObs);
                if (val2)
                    val2M = moment(val2);

                valCtx.write(val2M);
            })

            var editor = $("<div></div>");
            var tmp = $("<div></div>");
            tmp.addClass("flex-fill");

            tmp.append(editor);

            ctx.onDisplayed.push(() => {
                ko.applyBindingsToNode(editor[0], { dxDateBox: options });
            });

            return tmp;
        }

        init(element: Element, valueAccessor: () => KnockoutObservable<T> | ObservableOrValue<TOptions>, allBindings: KnockoutAllBindingsAccessor, vm: any, ctx: KnockoutBindingContext) {

            var self = this;

            var ctx2: ClickEditorBindingContext = { isEditing: false };

            ctx2.activate = () => this.activateEditor(ctx2, element, self.getOptions(valueAccessor, ctx));


            var options = self.getOptions(valueAccessor, ctx);

            switch (options.focus) {
                case "owner":
                    {
                        let elm = $(element);
                        if (options.appendTo)
                            elm = elm.closest(options.appendTo);

                        ctx2.owner = elm;

                        self.handleFocusEvents(elm, ctx2);

                    }
                    break;

                default:
                    ko.applyBindingsToNode(element, { click: () => { ctx2.activate(); return false; } }, ctx);
                    break;
            }


        }
        protected handleFocusEvents(elm: JQuery<Element>, ctx2: ClickEditorBindingContext): any {

            elm.on("focusin", ctx2.activate);


            elm.on("focusout", evnt => {

                if (!document.hasFocus() || !ctx2.isEditing) return;

                var ctx = ctx2.ctx;

                if (utils.isSameElementOrDescendant(elm[0], <any>evnt.relatedTarget))
                    return;

                ctx.remove();
            });

        }

        getHandler(): KnockoutBindingHandler<Node, T> {
            return {
                init: this.init.bind(this)
            };
        }
    }

    class ClickEditTextBindingHandler extends ClickEditBindingHandlerBase<string>{

        getEditor(options: ClickEditOptions<string>, ctx: ClickEditorContext): JQuery {

            var cnt = this.createEditorContainer(ctx, options);

            var valCtx = ClickEditBindingHandlerBase.getEditorValueContext(options.value, options.label);

            if (valCtx.label != null) {
                var lbl = this.createLabel(ko.unwrap(valCtx.label), valCtx.id);
                cnt.append(lbl);
            }

            var editor: JQuery = null;
            editor = this.getTextEditor(valCtx, ctx);
            cnt.append(editor);

            return cnt;
        }

    }

    ko.bindingHandlers.clickEditTxt = new ClickEditTextBindingHandler().getHandler();



    export type CollapsePanelOptions = {
        isCollapsed?: ObservableOrValue<boolean>;
        id?: string;
        title?: ObservableOrValueReadonly<string>;
        icon?: string;
        template?: string;
        headerLevel?: number;
        contentTemplate?: ObservableOrValueReadonly<DialogTemplate>;
        data?: any
    }

    export type BodyBindingInfo = { body: Node[], ctx: KnockoutBindingContext, template?: ObservableOrValueReadonly<DialogTemplate> };
    export type LayoutBindingContext = KnockoutBindingContext & { $body: BodyBindingInfo };

    function extendContextForBody(element: KnockoutVirtualElement | Node, ctx: KnockoutBindingContext, template?: ObservableOrValueReadonly<DialogTemplate>): LayoutBindingContext {
        var body = $.map(ko.virtualElements.childNodes(element), n => n);
        ko.virtualElements.emptyNode(element);

        body = body.filter(n => {
            if (n.nodeType == 3) {
                return ! /^\s*$/.test(n.textContent);
            }
            return true;
        });
        let info: BodyBindingInfo = { body, ctx }
        if (template)
            info.template = template

        return <any>ctx.extend({ $body: info });
    }

    ko.bindingHandlers.collapsePanel = new class CollapsePanelHandler implements KnockoutBindingHandler<Element, CollapsePanelOptions, any> {
        private _template: { [key: string]: Node[] } = {};


        init(element: Element, valueAccessor: () => CollapsePanelOptions, allBindings: KnockoutAllBindingsAccessor, vm: any, ctx: KnockoutBindingContext) {
            var value = valueAccessor() || {};


            ctx = ctx.extend({ $panel: value });

            ctx = extendContextForBody(element, ctx, value.contentTemplate);

            if (!ko.isWriteableObservable(value.isCollapsed)) {
                value.isCollapsed = ko.observable(typeof value.isCollapsed == "boolean" ? value.isCollapsed : false);
            }
            if (!value.id || typeof value.id !== "string")
                value.id = getUniqueId(value.isCollapsed);

            var nodes: Node[] = null;
            if (!value.template) {
                let forCard = false;
                let withIcon = Boolean(value.icon);
                let headerLevel = ko.unwrap(value.headerLevel);

                if (utils.equalsIgnoreCase(element.tagName, "div") && element.classList.contains("card")) {
                    forCard = true;
                }

                if (headerLevel == null) headerLevel = 4;


                nodes = this.getTemplate(forCard, withIcon, headerLevel);
            }

            let tOptions: MappableObject = { data: value, nodes: nodes };
            if (value.template)
                tOptions.name = value.template;

            ko.applyBindingsToNode(element, { template: tOptions }, ctx);

            return { controlsDescendantBindings: true };
        }

        getTemplate(forCard: boolean, withIcon: boolean, headerLevel: number): Node[] {

            var type = (forCard ? "card" : "norma")
                + (withIcon ? "-icon" : "")
                + (headerLevel > 0 ? "-h" + headerLevel : "");


            var res = this._template[type]
            if (!res) {
                this._template[type] = res = this.createTemplate(forCard, withIcon, headerLevel);
            }
            return res;
        }

        createTemplate(forCard: boolean, withIcon: boolean, headerLevel: number) {
            let container = document.createElement("div");

            let header = document.createElement("a");
            header.classList.add("d-flex");
            if (forCard) header.classList.add("card-header");

            header.setAttribute("data-bind", "click: function(){ isCollapsed(!isCollapsed()); },attr: {href: '#'+ $data.id }");

            var tmp = headerLevel > 0 && headerLevel <= 6 ? "h" + headerLevel : "div";
            let heading = document.createElement(tmp);
            heading.classList.add("my-auto");
            {
                if (withIcon) {
                    let ico = document.createElement("span");
                    ico.setAttribute("data-bind", "class: $data.icon");
                    heading.appendChild(ico);
                }

                let txt = document.createElement("span");
                txt.setAttribute("data-bind", "text: $data.title");
                heading.appendChild(txt);

            }
            header.appendChild(heading);

            let mark = document.createElement("span");
            mark.classList.add("fa");
            mark.setAttribute("data-bind", "class: 'fa-chevron-'+(ko.unwrap($data.isCollapsed)?'right':'down')")
            mark.classList.add("ml-auto", "my-auto", "mr-1");
            header.appendChild(mark);


            container.appendChild(header);


            let content = document.createElement("div");
            if (forCard)
                content.classList.add("card-body");
            else
                content.classList.add("my-3");
            content.setAttribute("data-bind", "collapse: isCollapsed, attr: {id: $data.id}, body: $data.data");

            container.appendChild(content);


            return [container];
        }

        getHandler() {
            return {
                init: this.init.bind(this)
            };
        }
    }().getHandler();

    // TODO Bindinghandler for Widgets
    ko.virtualElements.allowedBindings.widget = true;
    class WidgetBindinghandler implements KnockoutBindingHandler {
        private _template: Element

        init(elm: Element, valueAccessor: () => IWidgetDefinition, allBindings: KnockoutAllBindingsAccessor, vm: any, ctx: KnockoutBindingContext) {

            if (!this._template)
                this.createTemplate();

            let def = valueAccessor();
            ctx = ctx.extend({ widget: def });

            let def2: CollapsePanelOptions = {
                title: def.title,


                // contentTemplate: def.template,
            };

            let bindings: MappableObject = { collapsePanel: def2 };
            if (def.visible != null)
                bindings.visible = def.visible;

            let elm2 = this._template.cloneNode(true);

            ko.virtualElements.insertAfter(elm, elm2, null);


            ko.applyBindingsToNode(elm2, bindings, ctx);
            return { controlsDescendantBindings: true };

        }

        createTemplate(): any {
            let elm = document.createElement("div");
            elm.classList.add("card");

            let bodyElm = document.createElement("div");
            elm.append(bodyElm);

            bodyElm.setAttribute("data-bind", "diaTemplate: {" +
                "template: widget.template, " +
                "data: ko.unwrap(widget.viewModel || widget)" +
                "}")

            this._template = elm;
        }


        getHandler(): KnockoutBindingHandler {
            return {
                init: this.init.bind(this)
            };
        }
    }
    ko.bindingHandlers.widget = new WidgetBindinghandler().getHandler();

    ko.virtualElements.allowedBindings.diaTemplate = true;
    ko.bindingHandlers.diaTemplate = {

        init(element: Element, valueAccessor: () => { template: ObservableOrValue<DialogTemplate>, data: any }, all, vm: any) {
            let val = valueAccessor();
            if (typeof val == "string") {

                val = {
                    template: { type: "id", value: val },
                    data: vm
                };

            }

            let _template = utils.asyncComputed2(() => utils.loadTemplate(ko.unwrap(val.template)));

            ko.utils.domData.set(element, "diaTemplate_vm", val.data);
            ko.utils.domData.set(element, "diaTemplate_t", _template);

            return { controlsDescendantBindings: true };
        },

        update(element: Element, valueAccessor: any, allBindings, vm, ctx: KnockoutBindingContext) {
            let data: any = ko.unwrap(ko.utils.domData.get(element, "diaTemplate_vm"));
            let _template: KnockoutAsyncComputed<string> = ko.utils.domData.get(element, "diaTemplate_t");

            //let $element = $(element);

            ////// Clean Node
            ////ko.cleanNode(element);
            ////// Add the DOM-Data that was removed
            ////ko.utils.domData.set(element, "diaTemplate_vm", data);
            ////ko.utils.domData.set(element, "diaTemplate_t", _template);

            ko.virtualElements.emptyNode(element);
            if (_template.isLoading()) {
                let elm = document.createElement("div");
                ko.virtualElements.insertAfter(element, elm, null);

                ko.applyBindingsToNode(elm, { dxLoadPanel: getLoadPanelOptions({ visible: true, position: { at: "center", of: element } }) }, ctx)

                //$element.html("<div data-bind='dxLoadPanel: options'></div>");
                //ko.applyBindingsToDescendants({
                //    options: getLoadPanelOptions({ visible: true, position: { at: "center", of: element } })
                //}, element);
            }
            else {
                let t = ko.unwrap(_template);
                if (t) {
                    let nodes = $.parseHTML(t);

                    let n1: Node = null;
                    nodes.forEach(n => {
                        ko.virtualElements.insertAfter(element, n, n1);
                        n1 = n;
                    });
                    let ctx2 = ctx.createChildContext(ko.unwrap(data));
                    ko.applyBindingsToDescendants(ctx2, element);
                }

                //$element.html(t || "");
                //if (t) {
                //    let ctx2 = ctx.createChildContext(ko.unwrap(data));

                //    ko.applyBindingsToDescendants(ctx2, element);
                //}
            }


        }
    }


    type PopoverMenuOptions = {
        data: any,
        menu: IActionGroupDefinition[],

        displayExpr?: string,
        clickExpr?: string,
    };
    ko.bindingHandlers.clickMenu = new class ClickMenuBindingHandler implements KnockoutBindingHandler<Element, PopoverMenuOptions> {

        init(element: Element, valueAccessor: () => PopoverMenuOptions, allBindings: KnockoutAllBindingsAccessor, vm: any, ctx: KnockoutBindingContext) {

            var value = valueAccessor();

            if (value) {
                var visible = ko.observable(false);

                var options = <ObservableOrValueModel<DevExpress.ui.dxContextMenuOptions>>{
                    visible: visible,
                    target: element,
                    showEvent: "dxclick dxcontextmenu",

                    displayExpr: "caption",
                    disabledExpr: "disable",


                    onItemClick: e => {
                        let cl = e.itemData.click;
                        if (value.clickExpr && typeof e.itemData[value.clickExpr] == "function")
                            cl = e.itemData[value.clickExpr].bind(e.itemData);

                        if (cl) {
                            let arg: any = undefined;
                            if (value.data) {
                                // TODO GetData;
                                arg = ko.unwrap(value.data);
                            }

                            cl(arg);
                        }
                    },
                    position: {
                        my: "top", at: "bottom", of: element, collision: "flipfit"
                    }
                };

                if (value.displayExpr)
                    options.displayExpr = value.displayExpr;

                if (value.menu) {
                    // This computed is necessary, since the control won't notice changes in the items collections of items.
                    // This computed makes it so the top-level items are dependant on the nested Elements children
                    var cmp = ko.pureComputed(() => {
                        let items = ko.unwrap(value.menu)
                        let tmp = [...items];

                        while (tmp.length) {
                            let tmp2 = tmp.shift();

                            if (tmp2 && tmp2.items) {
                                tmp.push(...ko.unwrap(tmp2.items));
                            }
                        }

                        return items;
                    });
                    options.items = <any>cmp;

                    var s = cmp.subscribe(updateElementForMenu);
                    ko.utils.domNodeDisposal.addDisposeCallback(element, () => s.dispose());

                }
                ctx = ctx.createChildContext(options);

                var elm2 = document.createElement("div");

                element.after(elm2);
                ko.utils.domNodeDisposal.addDisposeCallback(element, () => elm2.remove());

                ko.applyBindingsToNode(elm2, { dxContextMenu: options }, ctx);
            }

            updateElementForMenu(ko.unwrap(options.items));

            function updateElementForMenu(i?: IActionGroupDefinition[]) {
                if (i && i.length)
                    element.classList.remove("d-none");
                else
                    element.classList.add("d-none");
            }

        }

        getHandler(): KnockoutBindingHandler<Element> {

            return <KnockoutBindingHandler<Element>>{
                init: this.init.bind(this),

            }

        }


    }().getHandler();

    ko.virtualElements.allowedBindings.body = true;
    ko.virtualElements.allowedBindings.layout = true;
    ko.virtualElements.allowedBindings.collapsePanel = true;
    ko.bindingHandlers.layout = {
        init: (element: Element, valueAccessor: () => string, allBindings, vm, ctx) => {

            var ctx2 = extendContextForBody(element, ctx);

            ko.applyBindingsToNode(element, { template: valueAccessor() }, ctx2);

            return { controlsDescendantBindings: true };
        }
    };

    ko.bindingHandlers.body = {
        init: (element: Element, valueAccessor: () => any, allBindings, vm, ctx: LayoutBindingContext) => {

            var b = ctx.$body;
            if (b) {
                var val = valueAccessor();
                if (val === undefined) val = b.ctx.$data;

                if (!b.template)
                    ko.applyBindingsToNode(element, { template: { data: val, nodes: b.body } }, b.ctx);
                else
                    ko.applyBindingsToNode(element, { diaTemplate: { template: b.template, data: val } }, b.ctx);
            }

            return { controlsDescendantBindings: true };
        }
    };

    /** Binds formattedNumbers (readonly) */
    // usage 1: data-bind="formatNumber: value, numberFormat: 'N0'"
    // usage 2: data-bind="formatNumber: {data:value, format: 'N0'}"
    // usage 3: data-bind="formatNumber: [value, 'N0']"
    ko.bindingHandlers.formatNumber = {
        init: function (element: HTMLElement, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            var observable = valueAccessor()

            var format: string | Globalize.NumberFormatterOptions;

            if (typeof observable === "object" && observable != null && observable.data) {
                format = observable.format;
                observable = observable.data;
            }
            else if ($.isArray(observable)) {
                format = observable[1];
                observable = observable[0];
            }
            else
                format = allBindingsAccessor.get("numberFormat");

            var { formatter } = utils.formatting.getNumberFormatter(format);

            // Q> Make interceptor writeable?
            var interceptor = ko.computed(() => {

                var val = ko.unwrap(observable);

                if (val == null) return "";

                return ko.unwrap(formatter)(val);
            });

            if (utils.equalsIgnoreCase(element.tagName, 'input')) {
                ko.applyBindingsToNode(element, { value: interceptor });
            } else {
                ko.applyBindingsToNode(element, { text: interceptor });
            }
        }
    }



    /** Binds formatted Values(readonly) */
    // usage 1: data-bind="format: value, formatString: 'N0'"
    // usage 2: data-bind="format: {data:value, format: 'N0', formatter: <formatter>}"
    // usage 3: data-bind="format: [value, 'N0', <formatter>]"
    ko.bindingHandlers.format = {
        init: function (element: HTMLElement, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            var observable = valueAccessor()

            var format: string;
            var formatter: utils.formatting.IValueFormatter<unknown> = null;

            if (typeof observable === "object" && observable != null && observable.data) {
                format = observable.format;
                formatter = observable.formatter;
                observable = observable.data;
            }
            else if ($.isArray(observable)) {
                format = observable[1];
                formatter = observable[2];
                observable = observable[0];
            }
            else {
                format = allBindingsAccessor.get("formatString");
                formatter = allBindingsAccessor.get("formatter");
            }

            if (!formatter) formatter = utils.formatting.defaultFormatter;
            if (ko.isObservable(observable)) {
                let dtObs = <KnockoutDateExtender | KnockoutTimeSpanExtender>observable;
                if (dtObs.state) {
                    observable = dtObs.state().value;
                }
            }


            var formatFunc = formatter.prepareFormatter(format);

            // Q> Make interceptor writeable?
            var interceptor = ko.computed(() => {
                return formatFunc(ko.unwrap(observable));
            });

            if (utils.equalsIgnoreCase(element.tagName, 'input')) {
                ko.applyBindingsToNode(element, { value: interceptor });
            } else {
                ko.applyBindingsToNode(element, { text: interceptor });
            }
        }
    }

    export type uniqueContext = { counter: number, readonly prefix: string, varName?: string }
    var uniqueCfg = {
        counter: 0,
        prefix: "unique",


    }

    export const getUniqueId = function (value: any, ctx?: uniqueContext) {
        ctx = ctx || uniqueCfg;
        var idMod = ctx.varName || "id-0";
        var prefix = ctx.prefix || "unique";

        return value[idMod] = value[idMod] || prefix + (++ctx.counter);
    };

    // From https://stackoverflow.com/a/11536424
    ko.bindingHandlers.uniqueId = ko.bindingHandlers.uniqueFor = {
        init: function (element: Element, valueAccessor, allBindingsAccessor) {
            var value = valueAccessor();
            var suffix = ko.unwrap(allBindingsAccessor().uniqueMod);

            var id = getUniqueId(value);
            if (suffix != null)
                id += "-" + suffix;

            if (utils.equalsIgnoreCase(element.tagName, "LABEL"))
                element.setAttribute("for", id);
            else
                element.id = id;
        }
    };

    ko.bindingHandlers.fileMgr = {
        init: function (element: Element, valueAccessor: () => DevExpress.fileManagement.FileSystemProviderBase, allBindings) {

            var elm2 = document.createElement("div");
            element.appendChild(elm2);

            var fsp = valueAccessor();

            var options: DevExpress.ui.dxFileManagerOptions = {
                fileSystemProvider: fsp,
                permissions: { download: true, upload: true, rename: true, delete: true, create: true },
                allowedFileExtensions: [],

                itemView: {
                    details: {
                        columns: [
                            { dataField: 'name', dataType: 'string', caption: t("dxFileManager-listDetailsColumnCaptionName") },
                            { dataField: 'dateModified', dataType: 'date', caption: t("dxFileManager-listDetailsColumnCaptionDateModified"), width: "auto" },
                            { dataField: 'size', dataType: 'string', caption: t("dxFileManager-listDetailsColumnCaptionFileSize") }
                        ]
                    }
                },
                customizeDetailColumns(e) {
                    var cols = e.slice();

                    var col = cols.find(c => c.dataField == "dateModified");
                    (col as any).format = { formatter: utils.formatting.dateFormatter.prepareFormatter("G") };

                    return cols;
                }

            };

            if (allBindings.has("selectedFile")) {
                var selFileObs = allBindings.get("selectedFile");

                var filter: { (name: string, path: string): boolean } = allBindings.get("fileFilter");
                if (typeof (filter) != "function") filter = null;

                if (ko.isWriteableObservable(selFileObs)) {
                    selFileObs(null);
                    options.onSelectionChanged = e => {
                        var name: string = null;
                        var res: string = null;

                        if (e.selectedItems && e.selectedItems.length) {
                            var item = e.selectedItems[0];

                            if (item && item.dataItem) {
                                name = item.name;
                                res = item.dataItem.virtualPath;
                            }

                        }

                        // Q> Filter
                        if (res && filter && !filter(name, res))
                            res = null;

                        selFileObs(res);
                    }
                    options.selectionMode = "single";
                }

            }


            $(elm2).dxFileManager(options);

            var fileMgr = DevExpress.ui.dxFileManager.getInstance(elm2) as DevExpress.ui.dxFileManager;

            if (ko.isObservable(fsp)) {
                fsp.subscribe(fsp2 => {
                    fileMgr.option("fileSystemProvider", fsp2);
                });
            }


            return { controlsDescendantBindings: true };
        }
    }


    // #endregion

    // #region DevExtreme EventHandler
    let dblClickOffset = 300;

    /**
     * checks whether a click is a double Click and calls the handler
     * @param e Event of the DevExtreme Widget
     * @param onDblClick Handler for the DoubleClick
     * @param onSingleClick Handler for a SingleClick
     */
    export function handleDblClick<TCmp extends DevExpress.DOMComponent, T>(e: DxWidgetEventArgs<TCmp, T>, onDblClick: DxEventHandlerBase<TCmp, T>, onSingleClick?: DxEventHandlerBase<TCmp, T>) {
        let component: { lastClickTime?: Date, clickTimer?: number } = <any>e.component;
        let prevClickTime = component.lastClickTime;

        component.lastClickTime = new Date();
        if (prevClickTime && (component.lastClickTime.valueOf() - prevClickTime.valueOf() < dblClickOffset)) {
            if (component.clickTimer)
                clearTimeout(component.clickTimer);
            //Double click code
            console.log('double click');
            onDblClick(e);
        }
        else {

            if (onSingleClick)
                component.clickTimer = setTimeout(() => {
                    component.clickTimer = undefined;

                    //Single click code
                    console.log('single click');
                    onSingleClick(e);
                }, dblClickOffset);
        }

    }

    export function searchDialogRowClickHandler<T extends { dialogResult: KnockoutObservable<boolean> }>(e: DxDataGridRowClickedEventArgs<DevExpress.ui.dxDataGrid, T>) {
        handleDblClick(e, e => {
            e.model.dialogResult(true);
        });
    }

    export function searchDialogSelectionChangedHandler<T extends { selected: KnockoutObservable<TKey[]>, selectedItems?: KnockoutObservable<TModel[]> }, TModel, TKey>(e: DxDataGridSelectionChangedEventArgs<DevExpress.ui.dxDataGrid, T, TModel, TKey>) {
        e.model.selected(e.selectedRowKeys);
        if (ko.isWriteableObservable(e.model.selectedItems))
            e.model.selectedItems(e.selectedRowsData);
    }

    export function selectedItems<T>(selItem: KnockoutObservable<T>) {
        return ko.pureComputed({
            read: () => {
                var i = ko.unwrap(selItem);
                return i ? [i] : [];
            },
            write: arr => {
                selItem(arr[0]);
            }
        });
    }

    export function getObservableStore<T>(arr: KnockoutObservableArray<T>) {

        let d = ko.unwrap(arr) || [];
        let s = new DevExpress.data.ArrayStore({ data: d, onModified: function () { arr(d) } });

        return s;
    }

    export var autoFocusDelay = 150;
    export function initializedFocusHandler(e: DxWidgetEventArgs<DevExpress.ui.Widget, unknown> | ObservableOrValue<boolean>) {

        e = ko.unwrap<DxWidgetEventArgs<DevExpress.ui.Widget, unknown> | boolean>(e);

        if (e && typeof (e) == "object" && "component" in e) {
            let cmp = e.component;

            let elm = $(e.element.closest(".dx-popup, .dx-popover, .dx-tabpanel")) as JQuery;

            let pElm = DevExpress.ui.dxPopup.getInstance(elm) || DevExpress.ui.dxPopover.getInstance(elm);
            if (pElm) {
                pElm.on("shown", () => focus());

                pElm.element().on("focus", ".dx-overlay-content", e2 => {
                    focus();
                });
            }
            else if (elm.hasClass("dx-multiview")) {
                let mvCmp = (DevExpress.ui.dxTabPanel.getInstance(elm) || DevExpress.ui.dxMultiView.getInstance(elm)) as DevExpress.ui.dxMultiView & { isItemSelected(item: any): boolean };
                if (mvCmp && "isItemSelected" in mvCmp) {
                    let mvItem = cmp.element().closest(".dx-multiview-item");

                    mvCmp.on("selectionChanged", () => {
                        if (mvCmp.isItemSelected(mvItem))
                            focus();
                    });
                }
            }

            focus();

            function focus() {
                setTimeout(() => cmp.focus(), autoFocusDelay);
            }

        } else if (e !== false)
            return initializedFocusHandler;
    }

    // #endregion

}